<template>
  <div v-if="preloader">
    <template>
      <v-dialog v-model="preloader" hide-overlay persistent width="300">
        <v-progress-linear indeterminate></v-progress-linear>
      </v-dialog>
    </template>
  </div>
  <div v-else>
    <v-dialog
      v-if="assessmentPublishedDialog"
      v-model="assessmentPublishedDialog"
      max-width="366px"
      persistent
    >
      <v-card>
        <v-container fluid class="pa-8">
          <v-card-text class="d-flex flex-column align-center">
            <img class="cursor" width="96px" height="96px" :src="successIcon" />
            <p class="text-h5 text-center py-4">
              Assessment
              {{
                `${assessmentData.isEdit ? "Updated" : "Created"}`
              }}
              Successfully
            </p>
            <v-btn
              class="btn primary-btn"
              large
              width="180px"
              rounded
              @click="$router.push('/static-assessment')"
              >Ok</v-btn
            >
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="assessmentDraftDialog"
      v-model="assessmentDraftDialog"
      max-width="366px"
      persistent
    >
      <v-card>
        <v-container fluid class="pa-8">
          <v-card-text class="d-flex flex-column align-center">
            <v-icon color="success" size="96">mdi-check-circle-outline</v-icon>
            <p class="text-h5 text-center py-4">Assessment Draft Saved</p>
            <v-btn
              class="btn primary-btn"
              large
              width="157px"
              rounded
              @click="$router.push('/static-assessment')"
              >Ok</v-btn
            >
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>
    <v-card
      height="64px"
      width="100%"
      class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
      style="
        position: fixed;
        z-index: 200;
        top: 0;
        width: 98%;
        padding-top: 8px;
      "
    >
      <v-card-title class="ml-0">
        <span
          @click="$router.push('/static-assessment')"
          class="breadcrumb-text cursor underline-on-hover"
        >
          Assessment
        </span>
        <v-icon class="breadcrumb-arrow">mdi-chevron-right</v-icon>
        <p class="breadcrumb-text">
          {{
            `${
              assessmentData.isEdit ? "Edit" : "Create"
            } Assessment`
          }}
        </p>
        <span><v-icon class="breadcrumb-arrow">mdi-chevron-down</v-icon></span>
      </v-card-title>
      <UserNavMenu />
    </v-card>
    <div class="background" hide-overlay v-if="!preloader">
      <div class="background mt-4">
        <v-card-text>
          <v-stepper
            v-model="e1"
            elevation="0"
            class="background pad-create-assessment"
          >
            <v-stepper-header class="mx-6 white rounded-xl stepper-shadow">
              <v-stepper-step
                class="green--text py-0"
                complete-icon="mdi-check-bold"
                color="#4D695B"
                :complete="e1 > 1"
                step="1"
              >
                Assessment Configuration
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step
                class="green--text py-0"
                complete-icon="mdi-check-bold"
                color="#4D695B"
                :complete="e1 > 2"
                step="2"
              >
                Add Question
              </v-stepper-step>
            </v-stepper-header>
            <!-- stepper items starts here -->
            <v-card
              elevation="0"
              class="background mt-3 rounded-xl"
              id="myScroll"
              :class="'stepper-content-height'"
            >
              <v-stepper-items>
                <v-stepper-content class="pt-0" step="1">
                  <span class="current-step-top"></span>
                  <v-form ref="step1" lazy-validation>
                    <v-card outlined elevation="0" class="rounded-xl">
                      <v-card-text class="pt-10 px-10">
                        <v-row class="py-0">
                          <v-col class="py-0">
                            <v-autocomplete
                              v-model="assessmentData.modeOfAssessment"
                              :items="modeOfAssessmentList"
                              :disabled="assessmentData.isEdit"
                              outlined
                              class="rounded-xl"
                              :rules="[
                                (v) =>
                                  !!v ||
                                  'Please Select a Mode of Static Assessment type',
                              ]"
                              required
                              attach
                            >
                              <!-- Custom Label Slot -->
                              <template v-slot:label>
                                Select Assessment Mode <span class="required"
                                  >*</span
                                >
                              </template>

                              <!-- Custom item template -->
                              <template v-slot:item="{ item, on, attrs }">
                                <v-list-item disabled v-bind="attrs" v-on="on">
                                  <v-list-item-content>
                                    <v-list-item-title>{{
                                      item
                                    }}</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col class="py-0">
                            <v-text-field
                              outlined
                              class="rounded-xl"
                              v-model="assessmentData.assessmentName"
                              placeholder="Assessment Name Here"
                            
                              required
                              @input="validateAssessmentName"
                              :counter="100"
                              :rules="[
                                (v) => !!v || 'Please enter as assessment name',
                                (v) =>
                                  (v && v.length <= 100) ||
                                  'Assessment Name must be 100 characters or fewer',
                              ]"
                            >
                          <template v-slot:label>
                                Assessment Name <span class="required"
                                  >*</span
                                >
                              </template></v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="py-1 ma-0">
                          <v-col class="py-0 px-0">
                            <div class="text-body-1 pt-1">
                              Assessment Description
                            </div>
                            <ckeditor
                              :config="editorConfig"
                              v-model="assessmentData.assessmentDescription"
                              class="m-ckeditor"
                              :rules="[
                                (v) =>
                                  !!v || 'Assessment Description is required',
                                (v) =>
                                  (v &&
                                    stripHtml(v).length <=
                                      maxAssessmentDescriptionLength) ||
                                  `Maximum ${maxAssessmentDescriptionLength} characters allowed`,
                              ]"
                              required
                              @ready="onEditorReady"
                              @input="onEditorInput"
                            >
                            </ckeditor>
                          </v-col>
                        </v-row>
                        <v-row class="mt-0">
                          <v-col
                            class="d-flex justify-space-between mb-2 pt-0 mb-0"
                          >
                            <div
                              v-if="ckEditorError"
                              class="text-caption mt-1 red--text"
                            >
                              {{ ckEditorError }}
                            </div>
                            <div
                              class="text-right mt-1 ml-auto text-caption"
                              :class="
                                assessmentDescriptionLength >
                                maxAssessmentDescriptionLength
                                  ? 'red--text'
                                  : 'grey--text text--darken-2'
                              "
                            >
                              {{ assessmentDescriptionLength }} /
                              {{ maxAssessmentDescriptionLength }} characters
                            </div>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0">
                            <v-autocomplete
                              v-model="assessmentData.audienceRoleGroupId"
                            
                              item-value="id"
                              item-text="name"
                              :items="groupNamesList"
                              :disabled="assessmentData.isEdit"
                              @change="handleChange"
                              outlined
                              class="rounded-xl"
                              :rules="[
                                (v) => !!v || 'Please Select a Group Name',
                              ]"
                              required
                            >
                            <template v-slot:label>
                                Group Name <span class="required"
                                  >*</span
                                >
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col class="py-0">
                            <v-autocomplete
                              v-model="assessmentData.assessmentUserType"
                              
                              :disabled="
                                userTypeList?.length === 0 ||
                                assessmentData.isEdit
                              "
                              :items="userTypeList"
                              item-value="name"
                              item-text="name"
                              :item-disabled="(item) => item.name === 'Teacher'"
                              outlined
                              class="rounded-xl"
                              :rules="[
                                (v) => !!v || 'Please select an user type',
                              ]"
                              required
                              attach
                              @change="clearQuestions"
                            >
                            <template v-slot:label>
                                User Type <span class="required"
                                  >*</span
                                >
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0">
                            <v-autocomplete
                              @input="handleSkillsInput"
                              v-model="assessmentData.skillIds"
                              deletable-chips
                              label="Skills*"
                              outlined
                              class="rounded-xl"
                              chips
                              :items="skillsList"
                              :disabled="
                                skillsList?.length === 0 ||
                                assessmentData.isEdit
                              "
                              item-value="id"
                              item-text="name"
                              flat
                              dense
                              required
                              multiple
                              clearable
                              :rules="[(v) => !!v || 'skills are required']"
                              @change="clearQuestions"
                            >
                            <template v-slot:label>
                                Skills <span class="required"
                                  >*</span
                                >
                              </template>
                              <template #selection="{ item }">
                                <v-chip
                                  v-if="assessmentData.isEdit"
                                  text-color="#A3A3A3"
                                  color="#E0E0E0"
                                >
                                  {{ item.name }}
                                </v-chip>
                                <v-chip
                                  v-else
                                  @click:close="deleteChip('skillIds', item)"
                                  close-icon="mdi-close"
                                  text-color="#3F41D1"
                                  close
                                  color="#CFD5F1"
                                >
                                  {{ item.name }}
                                </v-chip>
                              </template>
                              <template v-slot:item="{ item, on, attrs }">
                                <v-list-item
                                  v-bind="attrs"
                                  v-on="on"
                                  :disabled="item.name !== 'Psychometry'"
                                >
                                  <v-list-item-action>
                                    <v-checkbox
                                      :input-value="
                                        assessmentData.skillIds.includes(
                                          item.id
                                        )
                                      "
                                    >
                                    </v-checkbox>
                                  </v-list-item-action>
                                  <v-list-item-content>
                                    <v-list-item-title>{{
                                      item.name
                                    }}</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                              <v-list-item
                                disabled
                                slot="prepend-item"
                                ripple
                                @click="selectAll('skills')"
                              >
                                <v-list-item-action>
                                  <v-checkbox
                                    :input-value="
                                      skillsList?.length ===
                                      assessmentData.skillIds?.length
                                    "
                                  >
                                  </v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title
                                    >Select All</v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item>
                            </v-autocomplete>
                          </v-col>
                          <v-col class="py-0">
                            <v-autocomplete
                              v-model="assessmentData.assessmentCategory"
                            
                              :items="assessmentCategoriesList"
                              item-value="id"
                              item-text="name"
                              outlined
                              class="rounded-xl"
                              @change="handleCategoryChange"
                              :disabled="
                                assessmentCategoriesList?.length === 0 ||
                                assessmentData.isEdit
                              "
                              :rules="[
                                (v) =>
                                  !!v || 'Please select an assessment category',
                              ]"
                              required
                              attach
                            >
                            <template v-slot:label>
                                Assessment Category <span class="required"
                                  >*</span
                                >
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6" class="py-0">
                            <v-autocomplete
                            
                              outlined
                              v-model="assessmentData.level"
                              required
                              :rules="[(v) => !!v || 'Please select a level']"
                              class="rounded-xl"
                              :items="levels"
                              item-text="name"
                              item-value="name"
                              flat
                              @change="
                                getGradesMappedToLevels($event);
                                clearQuestions;
                              "
                              :disabled="
                                assessmentData.isEdit ||
                                assessmentData.audienceRoleGroupId === ''
                              "
                            >
                            <template v-slot:label>
                                Level <span class="required"
                                  >*</span
                                >
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="6" class="py-0">
                            <v-autocomplete
                              @input="fetchSections"
                              @change="clearQuestions"
                              v-model="selectedGrade"
                              deletable-chips
                              label="Grades*"
                              outlined
                              class="rounded-xl"
                              :items="gradesList"
                              :disabled="
                                assessmentData?.level == '' ||
                                assessmentData?.level == undefined ||
                                assessmentData.isEdit
                              "
                              flat
                              dense
                              required
                              clearable
                              :rules="[(v) => !!v || 'Please select a grade']"
                            >
                            <template v-slot:label>
                                Grade <span class="required"
                                  >*</span
                                >
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col class="py-0">
                            <v-autocomplete
                              v-model="assessmentData.timerType"
                              @change="handleTimerTypeChange"
                              :disabled="assessmentData.isEdit"
                              
                              :items="timerTypeList"
                              outlined
                              class="rounded-xl"
                              :rules="[
                                (v) => !!v || 'Please select a timer type',
                              ]"
                              required
                              attach
                            >
                            <template v-slot:label>
                                Timer Type <span class="required"
                                  >*</span
                                >
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col class="py-0">
                            <v-autocomplete
                              @input="handleInputChange"
                              v-model="assessmentData.availableLanguages"
                              @change="clearQuestions"
                              clearable
                              deletable-chips
                              
                              outlined
                              class="rounded-xl"
                              chips
                              :items="languageOptions"
                              multiple
                              flat
                              dense
                              required
                              :rules="[(v) => !!v || 'languages are required']"
                              @click:clear="handleClear('availableLanguages')"
                              :disabled="assessmentData.isEdit"
                            >
                            <template v-slot:label>
                                Question Language <span class="required"
                                  >*</span
                                >
                              </template>
                              <template #selection="{ item }">
                                <v-chip
                                  v-if="assessmentData.isEdit"
                                  text-color="#A3A3A3"
                                  color="#E0E0E0"
                                >
                                  {{ item }}
                                </v-chip>
                                <v-chip
                                  v-else
                                  @click:close="deleteChip('languages', item)"
                                  close-icon="mdi-close"
                                  close
                                  text-color="#3F41D1"
                                  color="#CFD5F1"
                                  >{{ item }}</v-chip
                                >
                              </template>
                              <v-list-item
                                slot="prepend-item"
                                ripple
                                @click="selectAll('languages')"
                              >
                                <v-list-item-action>
                                  <v-checkbox
                                    :value="
                                      assessmentData.availableLanguages
                                        .length === languageOptions.length
                                    "
                                  ></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title
                                    >Select All</v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item>
                              <template v-slot:item="{ item, on, attrs }">
                                <v-list-item
                                  v-bind="attrs"
                                  v-on="on"
                                  :disabled="defaultLanguages.includes(item)"
                                >
                                  <v-list-item-action>
                                    <v-checkbox
                                      :input-value="
                                        assessmentData.availableLanguages.includes(
                                          item
                                        )
                                      "
                                    ></v-checkbox>
                                  </v-list-item-action>
                                  <v-list-item-content>
                                    <v-list-item-title>{{
                                      item
                                    }}</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="6">
                            <v-autocomplete
                              v-model="assessmentData.selectedSections"
                              clearable
                              deletable-chips
                              outlined
                              class="rounded-xl"
                              chips
                              :items="sectionsList"
                              :disabled="sectionsList?.length === 0 || assessmentData.isEdit"
                              @change="handleSectionsChange"
                              multiple
                              flat
                              dense
                              required
                              :rules="[(v) => !!v || 'Please select a grade']"
                              @click:clear="handleClear('sections')"
                            >
                              <template v-slot:label>
                                Section/Subject <span class="required">*</span>
                              </template>
                              <template #selection="{ item }">
                                <v-chip
                                  v-if="assessmentData.isEdit"
                                  text-color="#A3A3A3"
                                  color="#E0E0E0"
                                  class="ma-1"
                                >
                                  {{ item }}
                                </v-chip>
                                <v-chip
                                  v-else
                                  @click:close="deleteChip('sections', item)"
                                  close-icon="mdi-close"
                                  close
                                  text-color="#3F41D1"
                                  color="#CFD5F1"
                                  class="ma-1">
                                    {{ item }}
                                  </v-chip>
                              </template>
                              <v-list-item slot="prepend-item" ripple @click="selectAll('sections')">
                                <v-list-item-action>
                                  <v-checkbox
                                    :value="assessmentData.selectedSections.length === sectionsList.length"
                                  ></v-checkbox>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>Select All</v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                              <template v-slot:item="{ item, on, attrs }">
                                <v-list-item v-bind="attrs" v-on="on">
                                  <v-list-item-action>
                                    <v-checkbox
                                      :input-value="assessmentData?.selectedSections?.includes(item)"
                                    ></v-checkbox>
                                  </v-list-item-action>
                                  <v-list-item-content>
                                    <v-list-item-title>{{ item }}</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              :disabled="assessmentData.timerType === 'Section Level Timer'"
                              outlined
                              class="rounded-xl"
                              placeholder="0"
                              @input="restrictToPositiveIntegers($event, 'totalDuration')"
                              v-model="assessmentData.totalDuration"
                              label="Total Duration"
                              suffix="mins"
                              required
                              type="number"
                              :min="1"
                              :rules="[
                                (v) => (v !== '' && v !== null && v !== undefined) || 'Duration is required',
                                (v) => Number(v) > 0 || 'Duration must be a positive number',
                                (v) => Number.isInteger(Number(v)) || 'Duration must be an integer',
                              ]"
                            >
                            </v-text-field>
                          </v-col>

                        </v-row>
                        <v-row v-if="assessmentData.sections.length > 0">
                          <v-col
                            cols="6"
                            class="d-flex align-center justify-space-between py-0"
                          >
                            <v-label> Include Bio-Break? <span class="required">*</span></v-label>
                            <v-radio-group
                              required
                              :disabled="!$featureFlags.isEnabled('bio_break_static_assessment') || assessmentData.sections.length <= 1"
                              v-model="assessmentData.isBioBreakIncluded"
                            >
                              <div class="d-flex ma-0">
                                <v-radio
                                  class="px-6"
                                  label="YES"
                                  :value="true"
                                ></v-radio>
                                <v-radio
                                  class="px-6"
                                  label="NO"
                                  :value="false"
                                  @click="assessmentData.breakType = ''"
                                ></v-radio>
                              </div>
                            </v-radio-group>
                          </v-col>
                        </v-row>
                        <v-row v-if="assessmentData.isBioBreakIncluded">
                          <v-col cols="6">
                            <v-autocomplete
                              outlined
                              v-model="assessmentData.breakType"
                              required
                              class="rounded-xl"
                              :items="bioBreakTypeList"
                              :rules="[
                                (v) =>(v !== '' && v !== null && v !== undefined) ||'Bio-Break Type is required',
                              ]"
                            >
                            <template v-slot:label>
                                Bio-Break Type <span class="required"
                                  >*</span
                                >
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              v-model="assessmentData.maxBreakDuration"
                              type="number"
                              class="rounded-xl"
                              placeholder="0"
                              suffix="mins"
                              min="0"
                              outlined
                              required
                              :disabled="assessmentData?.timerType === 'Selective Section Timer' && assessmentData?.breakType !== 'Break Anytime'"
                              @input="restrictToPositiveIntegers($event,'maxBreakDuration')"
                              :hint="(assessmentData.breakType === 'Break Between Sections' && assessmentData?.timerType !== 'Selective Section Timer')
                                  ? 'This Is The Total Break Duration, Which Will Be Equally Split Across All Sections'
                                  : ''
                              "
                              persistent-hint
                              :rules="[ 
                                () => (assessmentData?.totalDuration >= assessmentData?.maxBreakDuration) || 'Max Break Duration cannot exceed Total Duration',
                                (v) => (v !== '' && v !== null && v !== undefined) || 'Max Break Duration is required',
                                (v) => Number.isInteger(Number(v)) || 'Max Break Duration must be an integer',
                              ]"
                            >
                              <template v-slot:label>
                                  Max Duration For Bio-Break <span v-if="assessmentData?.timerType !== 'Selective Section Timer' && assessmentData?.breakType === 'Break Between Sections'" class="required">*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>

                        <!-- Section Level Timer -->
                        <template v-if="assessmentData.sections.length > 0 && assessmentData.timerType === 'Section Level Timer'">
                          <v-row
                            v-for="(section, index) in assessmentData.sections"
                            :key="`${section.name}|${index}`"
                          >
                            <v-col cols="2" class="py-0">
                              <div class="pt-3">{{ section.name }}</div>
                            </v-col>
                            <v-col cols="4" class="py-0">
                              <v-text-field
                                outlined
                                class="rounded-xl"
                                placeholder="0"
                                suffix="mins"
                                v-model="section.duration"
                                @change="handleSectionDurationChange"
                                required
                                type="number"
                                :disabled="assessmentData.isEdit"
                                :min="1"
                                @input="allowPositiveNumbers($event, index, 'duration')"
                                :rules="[
                                  (v) => (v !== '' && v !== null && v !== undefined) || 'Duration is required',
                                  (v) => Number(v) > 0 || 'Duration must be a positive number',
                                  (v) => Number.isInteger(Number(v)) || 'Duration must be an integer',
                                ]"
                              >
                                <template v-slot:label>
                                  Duration <span class="required">*</span>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col cols="6" class="py-0">
                              <v-text-field
                                type="number"
                                outlined
                                class="rounded-xl"
                                :min="1"
                                v-model="section.noOfQuestions"
                                @input="allowPositiveNumbers($event, index, 'noOfQuestions')"
                                required
                                :disabled="assessmentData.isEdit"
                                @change="clearQuestions"
                                :rules="[
                                  (v) => (v !== '' && v !== null && v !== undefined) || 'No. of Questions per Language is required',
                                  (v) => Number(v) > 0 || 'No. of questions must be a positive number',
                                  (v) => Number.isInteger(Number(v)) || 'No. of questions must be an integer',
                                ]"
                              >
                                <template v-slot:label>
                                  No. of Questions (Per Language)<span class="required">*</span>
                                </template>
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </template>

                        <!-- Selective Section Timer -->
                        <draggable
                          v-else-if="assessmentData.sections.length > 0 && assessmentData.timerType === 'Selective Section Timer'"
                          v-model="assessmentData.sections"
                          handle=".drag-handle"
                          animation="200"
                          :scroll-sensitivity="60"
                          :force-fallback="true"
                          ghost-class="drag-ghost"
                          chosen-class="drag-chosen"
                          drag-class="drag-active"
                          @end="onSectionDragEnd"
                          class="mb-6"
                        >
                          <v-row
                            v-for="(section, index) in assessmentData.sections"
                            :key="`${section.name}|${index}`"
                          >
                            <v-col cols="12" class="d-flex gap-2">
                              <div>
                                <v-icon :class="!assessmentData.isEdit ? 'drag-handle' : 'disabled-drag'">mdi-drag</v-icon>
                              </div>
                              <div class="card-shadow d-flex flex-column flex-1 gap-2 px-4 pt-4">
                                <div class="d-flex align-center">
                                  <div class="font-weight-bold fs-5">{{ section.name }}</div>
                                </div>
                                <v-row>
                                  <v-col cols="6" class="d-flex align-center gap-3">
                                    <div class="mb-0">Section Timing<span class="required">*</span></div>
                                    <v-radio-group
                                      required
                                      @change="handleSectionTimingChange($event, index)"
                                      v-model="section.isTimedSection"
                                      row
                                      hide-details
                                      class="mt-0 pt-0"
                                    >
                                      <v-radio class="mr-4" label="Timed" :value="true"></v-radio>
                                      <v-radio label="Untimed" :value="false"></v-radio>
                                    </v-radio-group>
                                  </v-col>
                                  <v-col cols="6" v-if="assessmentData.breakType === 'Break Between Sections'">
                                    <v-text-field
                                      outlined
                                      class="rounded-xl"
                                      placeholder="0"
                                      suffix="mins"
                                      v-model="section.breakDuration"
                                      required
                                      type="number"
                                      :disabled="index === (assessmentData.sections.length - 1)"
                                      :min="0"
                                      :hint="`This bio break will be provided after the ${section.name} section`"
                                      persistent-hint
                                      dense
                                      @input="allowPositiveNumbers($event, index, 'breakDuration')"
                                      :rules="index === (assessmentData.sections.length - 1) ? [] : [
                                        (v) => (v !== '' && v !== null && v !== undefined) || 'Duration is required',
                                        () => (assessmentData.totalDuration > sectionStats.all.totalBreakDuration || 'Break Duration cannot exceed Assessment Duration')
                                      ]"
                                    >
                                      <template v-slot:label>
                                        Bio Break After Section <span class="required">*</span>
                                      </template>
                                    </v-text-field>
                                  </v-col>
                                </v-row>
                                <v-row class="ma-0">
                                  <v-col cols="6" class="py-0 pl-0">
                                    <v-text-field
                                      outlined
                                      class="rounded-xl"
                                      placeholder="0"
                                      suffix="mins"
                                      v-model="section.duration"
                                      @change="clearQuestions"
                                      required
                                      type="number"
                                      :disabled="assessmentData.isEdit || !section.isTimedSection"
                                      :min="1"
                                      @input="allowPositiveNumbers($event, index, 'duration')"
                                      :rules="!section.isTimedSection ? [] : [
                                        (v) => (assessmentData.totalDuration > sectionStats.timed.duration) || 'This duration must not be less than Total Duration',
                                        (v) => (v !== '' && v !== null && v !== undefined) || 'Duration is required',
                                        (v) => Number(v) > 0 || 'Duration must be a positive number',
                                        (v) => Number.isInteger(Number(v)) || 'Duration must be an integer',
                                      ]"
                                    >
                                      <template v-slot:label>
                                        Duration <span class="required">*</span>
                                      </template>
                                    </v-text-field>
                                  </v-col>
                                  <v-col cols="6" class="py-0 pr-0">
                                    <v-text-field
                                      type="number"
                                      outlined
                                      class="rounded-xl"
                                      :min="1"
                                      v-model="section.noOfQuestions"
                                      @input="allowPositiveNumbers($event, index, 'noOfQuestions')"
                                      required
                                      :disabled="assessmentData.isEdit"
                                      @change="clearQuestions"
                                      :rules="[
                                        (v) => (v !== '' && v !== null && v !== undefined) || 'No. of Questions per Language is required',
                                        (v) => Number(v) > 0 || 'No. of questions must be a positive number',
                                        (v) => Number.isInteger(Number(v)) || 'No. of questions must be an integer',
                                      ]"
                                    >
                                      <template v-slot:label>
                                        No. of Questions (Per Language)<span class="required">*</span>
                                      </template>
                                    </v-text-field>
                                  </v-col>
                                </v-row>
                              </div>
                            </v-col>
                          </v-row>
                        </draggable>
                        <v-row v-if="assessmentData.sections.length > 0">
                          <v-col cols="6" class="py-0">
                            <v-text-field
                              outlined
                              class="rounded-xl"
                              placeholder="0"
                              v-model="totalQuestions"
                              
                              disabled
                              required
                            >
                              <template v-slot:label>
                                Total Questions (All Languages) <span class="required"
                                  >*</span
                                >
                              </template>
                            </v-text-field>
                              
                          </v-col>
                        </v-row>
                        <v-row v-if="assessmentData.sections.length > 0 && assessmentData.timerType === 'Selective Section Timer'">
                          <v-col class="py-0">
                            <v-text-field
                              outlined
                              class="rounded-xl"
                              placeholder="0"
                              :value="sectionStats.timed.duration"
                              disabled
                              required
                              :hint="sectionStats.timed.hint"
                              persistent-hint
                            >
                              <template v-slot:label>
                                Timed Section Duration<span class="required">*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                          <v-col class="py-0">
                            <v-text-field
                              outlined
                              class="rounded-xl"
                              placeholder="0"
                              :value="sectionStats.untimed.duration"
                              disabled
                              required
                              :hint="sectionStats.untimed.hint"
                              persistent-hint
                            >
                              <template v-slot:label>
                                Untimed Section Duration<span class="required">*</span>
                              </template>
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col
                            cols="6"
                            class="d-flex align-center justify-space-between py-0"
                          >
                            <v-label>
                              Reshuffle Required?<span class="required">*</span></v-label
                            >
                            <v-radio-group
                              required
                              v-model="assessmentData.isReshuffleRequired"
                            >
                              <div class="d-flex ma-0">
                                <v-radio
                                  class="px-6"
                                  label="YES"
                                  value="YES"
                                ></v-radio>
                                <v-radio
                                  class="px-6"
                                  label="NO"
                                  value="NO"
                                ></v-radio>
                              </div>
                            </v-radio-group>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-form>
                </v-stepper-content>

                <v-stepper-content class="pt-0" step="2">
                  <span class="current-step-top"></span>
                  <div v-if="secondLoader">
                    <template>
                      <v-dialog
                        v-model="secondLoader"
                        hide-overlay
                        persistent
                        width="300"
                      >
                        <v-progress-linear indeterminate></v-progress-linear>
                      </v-dialog>
                    </template>
                  </div>
                  <v-form ref="step2" v-else>
                    <v-card
                      class="assessment-details d-flex flex-column rounded-xl pa-4 body-2 mb-3"
                    >
                      <v-row no-gutters>
                        <v-col cols="4" class="pa-1">
                          <v-row no-gutters>
                            <v-col cols="4" class="pa-0">
                              <span> Group Name </span>
                            </v-col>
                            <v-col cols="8" class="pa-0">
                              <div>
                                <span class="pr-2">-</span>
                                {{ groupNameForDisplay }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row no-gutters>
                            <v-col cols="5" class="pa-0">
                              <span> User Type </span>
                            </v-col>
                            <v-col cols="7" class="pa-0">
                              <div>
                                <span class="pr-2">-</span>
                                {{ assessmentData.assessmentUserType }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row no-gutters>
                            <v-col cols="4" class="pa-0">
                              <span> Skills </span>
                            </v-col>
                            <v-col cols="8" class="pa-0">
                              <div>
                                <span class="pr-2">-</span>
                                {{ skillNames.join(", ") }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="4" class="pa-1">
                          <v-row no-gutters>
                            <v-col cols="4" class="pa-0">
                              <span> Category </span>
                            </v-col>
                            <v-col cols="8" class="pa-0">
                              <div>
                                <span class="pr-2">-</span>
                                {{ categoryNameForDisplay }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row no-gutters>
                            <v-col cols="5" class="pa-0">
                              <span> Level </span>
                            </v-col>
                            <v-col cols="7" class="pa-0">
                              <div>
                                <span class="pr-2">-</span>
                                {{ assessmentData.level }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row no-gutters>
                            <v-col cols="4"class="pa-0">
                              <span> Grade </span>
                            </v-col>
                            <v-col cols="8" class="pa-0">
                              <div>
                                <span class="pr-2">-</span>
                                {{ assessmentData.grades.join(", ") }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="4" class="pa-1">
                          <v-row no-gutters>
                            <v-col cols="4" class="pa-0">
                              <span> Timer Type </span>
                            </v-col>
                            <v-col cols="8" class="pa-0">
                              <div>
                                <span class="pr-2">-</span>
                                {{ assessmentData.timerType }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row no-gutters>
                            <v-col cols="5" class="pa-0">
                              <span>Total Duration </span>
                            </v-col>
                            <v-col cols="7" class="pa-0">
                              <div>
                                <span class="pr-2">-</span>
                                {{assessmentData.totalDuration || 0}} mins
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row no-gutters>
                            <v-col cols="4" class="pa-0">
                              <span>Question Language</span>
                            </v-col>
                            <v-col cols="8" class="pa-0">
                              <div>
                                <span class="pr-2">-</span>
                                {{ assessmentData.availableLanguages.join(", ") }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                      <v-row no-gutters>
                        <v-col cols="4" class="pa-1">
                          <v-row no-gutters>
                            <v-col cols="4" class="pa-0">
                              <span> Bio-Break Required </span>
                            </v-col>
                            <v-col cols="8" class="pa-0">
                              <div>
                                <span class="pr-2">-</span>
                                {{ assessmentData?.isBioBreakIncluded ? 'Yes' : "No"}}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="4" class="pa-1">
                          <v-row no-gutters>
                            <v-col cols="5" class="pa-0">
                              <span> Reshuffle required </span>
                            </v-col>
                            <v-col cols="7" class="pa-0">
                              <div>
                                <span class="pr-2">-</span>
                                {{ assessmentData.isReshuffleRequired }}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-card>
                    <v-row>
                      <v-col cols="8" class="d-flex">
                        <v-card
                          class="d-flex flex-1 pa-4 assessment-details rounded-xl"
                        >
                          <v-row>
                            <v-col
                              :cols="assessmentData.sections.length / 12"
                              v-for="(
                                section, index
                              ) in assessmentData.sections"
                              :key="section.name"
                              class="d-flex"
                            >
                              <div class="d-flex">
                                <v-divider
                                  v-if="index !== 0"
                                  vertical
                                  class="create-assessment-divider mr-2"
                                ></v-divider>
                                <div class="d-flex flex-column justify-center">
                                  <div class="py-1 font-weight-bold">
                                    {{ section.name }}
                                  </div>
                                  <div class="d-flex py-1 gap-3">
                                    <div>Question</div>
                                    <span> - </span>
                                    <div
                                      class="font-weight-bold"
                                      v-if="allQuestions.length > 0"
                                    >
                                      {{ section.noOfQuestions }}
                                    </div>
                                    <div class="font-weight-bold" v-else>0</div>
                                  </div>
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                      <v-col cols="4" class="d-flex pl-0">
                        <v-card
                          class="d-flex justify-space-around section-title pa-4 assessment-details rounded-xl"
                        >
                          <div class="d-flex flex-column justify-center">
                            <div class="py-1 font-weight-bold text-no-wrap">
                              Total Questions
                            </div>
                            <div class="py-1">
                              <span v-if="allQuestions.length > 0">{{
                                allQuestions.length *
                                assessmentData.availableLanguages.length
                              }}</span>
                              / {{ totalQuestions }}
                            </div>
                          </div>
                          <v-divider class="pl-4" vertical></v-divider>
                          <div
                            v-if="
                              !skillNames.includes('Psychometry') &&
                              skillNames.length > 1
                            "
                            class="d-flex flex-column justify-center pl-2 ml-3"
                          >
                            <div class="py-1 font-weight-bold">Total Marks</div>
                            <div class="py-1 label-value">{{ totalMarks }}</div>
                          </div>
                          <div
                            v-else
                            class="pl-2 text-wrap text-caption d-flex align-center"
                          >
                            Note-Psychometry marks are computed in real time
                            based on your selected responses.
                          </div>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-card
                      class="question-card rounded-xl mt-3 pb-3"
                      v-if="allQuestions.length <= 0"
                    >
                      <v-card-actions class="px-3 pb-6">
                        <v-btn
                          @click="downloadTemplate"
                          text
                          class="mx-2 downloadColor"
                        >
                          <img
                            class="mr-2"
                            src="../../public/svgs/fi_share.svg"
                          />
                          <span class="blue--text">
                            Download Template Excel
                          </span>
                        </v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                      <div
                        class="d-flex justify-center mb-6 bg-surface-variant"
                      >
                        <div class="box2" @dragover.prevent>
                          <div
                            class="w-100 d-flex flex-row justify-center"
                            style="margin-top: 80px"
                          >
                            <img src="../assets/u_folder-upload.svg" />
                          </div>

                          <div
                            class="w-100 d-flex flex-row justify-center mt-4"
                          >
                            <div>
                              <div class="font-weight-light text-center">
                                Drag and drop a file or
                                <div class="uplaodbtn2">
                                  browse file
                                  <input
                                    type="file"
                                    @change="handleFileUpload"
                                    name="csv"
                                  />
                                </div>
                                <p class="grey--text">
                                  (Supported only .csv file)
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </v-card>
                    <div v-else>
                      <v-row class="mb-0">
                        <v-col cols="4">
                          <span class="text-h6 pb-5">Questions</span>
                        </v-col>
                      </v-row>

                      <v-card>
                        <template>
                          <v-data-table
                            v-model="selectedQuestions"
                            :single-select="singleSelect"
                            :headers="headers"
                            :items="allQuestions"
                            :items-per-page="tablePageSize"
                            item-key="questionId"
                            class="elevation-1 custom-table"
                            :options.sync="options"
                            hide-default-footer
                            ref="myTable"
                          :class=" isScrollable ? 'frozen-columns-table' : ''"
                          >
                            <template v-slot:header.questionId>
                              <span class="custom-header-class"
                                >Question Id</span
                              >
                            </template>
                            <template v-slot:header.questionStatement>
                              <span class="custom-header-class"
                                >Question Statement</span
                              >
                            </template>
                            <template v-slot:header.questionType>
                              <span class="custom-header-class"
                                >Question Type</span
                              >
                            </template>
                            <template v-slot:header.subject>
                              <span class="custom-header-class"
                                >Subject/Section</span
                              >
                            </template>
                            <template v-slot:header.actions>
                              <span class="custom-header-class">Actions</span>
                            </template>
                            <template
                              v-slot:[`item.questionStatement`]="{ item }"
                            >
                              <v-tooltip bottom max-width="40vw">
                                <template #activator="{ on }">
                                  <div
                                    v-on="on"
                                    class="question-statement-cell"
                                    v-html="item.questionStatement"
                                  ></div>
                                </template>
                                <div v-html="item.questionStatement"></div>
                              </v-tooltip>
                            </template>
                            <template v-slot:[`item.subject`]="{ item }">
                              {{ displaySubjectsOrSections(item) }}
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                              <div>
                                <img
                                  width="36px"
                                  height="36px"
                                  class="cursor"
                                  src="../assets/edit.svg"
                                  @click="
                                    redirectToEditStaticAssessmentQuestion(
                                      item.questionId
                                    )
                                  "
                                />
                              </div>
                            </template>
                            <template v-slot:footer="{ props }">
                              <table-footer
                                :pagination="props.pagination"
                                :options="props.options"
                                @update-options="onFooterUpdate"
                              />
                            </template>
                          </v-data-table>
                        </template>
                      </v-card>
                    </div>

                    <!-- <v-dialog max-width="600px" max-height="80vh" v-model="uploadingTopicsDialog" center> -->

                    <v-dialog
                      class="cdz"
                      max-width="600px"
                      v-model="uploadingTopicsDialog"
                    >
                      <v-card class="pa-6">
                        <!-- Title and Progress -->
                        <div>
                          <h2>Upload File</h2>
                          <h4 v-if="failedRowCount <= 0" class="mt-2">
                            Please wait completing upload...
                          </h4>
                          <h4 v-else class="mt-2">
                            Invalid records in Excel. Please correct and
                            re-upload
                          </h4>
                          <v-progress-linear
                            value="100"
                            rounded
                            height="20"
                            class="mt-4"
                            color="blue"
                          ></v-progress-linear>
                          <p>{{ fileName }}</p>
                        </div>

                        <!-- Success & Failure Counts -->
                        <v-row justify="end" class="mt-4">
                          <v-col cols="auto">
                            <p
                              style="font-size: 14px"
                              class="success--text mb-0"
                            >
                              Successful: {{ successfullRowCount }}
                            </p>
                          </v-col>
                          <v-col cols="auto">
                            <p style="font-size: 14px" class="error--text mb-0">
                              Unsuccessful: {{ failedRowCount }}
                            </p>
                          </v-col>
                        </v-row>

                        <!-- Actions -->

                        <v-row no-gutters align="center" class="w-100 pt-4">
                          <!-- Left: Download Error Log -->
                          <v-col cols="6" class="d-flex align-center">
                            <div class="d-flex align-center">
                              <img
                                class="mr-2"
                                :src="
                                  failedRowCount > 0
                                    ? require('../assets/enable_share.svg')
                                    : require('../assets/fi_share.svg')
                                "
                                alt="Download Icon"
                              />
                              <p
                                class="mb-0 cursor-pointer pt-1"
                                @click="
                                  failedRowCount > 0 && downloadFailedRows()
                                "
                                :style="{
                                  color:
                                    failedRowCount > 0
                                      ? 'var(--blue-01)'
                                      : 'grey',
                                }"
                              >
                                DOWNLOAD ERROR LOG
                              </p>
                            </div>
                          </v-col>

                          <!-- Right: Cancel and Upload Buttons -->
                          <v-col
                            cols="6"
                            class="d-flex justify-end align-center"
                          >
                            <v-btn
                              @click="clearDataAndClose"
                              depressed
                              class="btn outline-btn mx-2"
                              large
                              outlined
                              rounded
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              v-if="failedRowCount <= 0"
                              depressed
                              rounded
                              class="btn primary-btn"
                              :loading="uploadingQuestions"
                              @click="uploadConfirm"
                            >
                              Upload
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-card>
                    </v-dialog>

                    <v-dialog
                      v-model="showConfirmDialog"
                      class="cdz"
                      max-width="400px"
                      min-height="294px"
                      persistent
                    >
                      <v-card>
                        <v-container fluid class="pa-2">
                          <v-card-text
                            class="text-center d-flex flex-column align-center"
                          >
                            <img src="../assets/done.svg" />
                            <p class="text-h5 text-center py-4">
                              Questions Added Successfully
                            </p>

                            <v-btn
                              class="btn primary-btn w-100"
                              large
                              @click="displayQuestionList"
                              rounded
                              >Ok</v-btn
                            >
                          </v-card-text>
                        </v-container>
                      </v-card>
                    </v-dialog>

                    <v-dialog
                      v-model="alertDialog"
                      class="cdz"
                      max-width="424px"
                      min-height="303px"
                      persistent
                      content-class="rounded-lg"
                    >
                      <v-card>
                        <v-container fluid class="py-4">
                          <v-card-text
                            class="text-center d-flex flex-column align-center gap-4"
                          >
                            <img :src="alertDialogContents[alertType]?.icon" />
                            <p class="font-weight-bold alert-title"> {{ alertDialogContents[alertType]?.title }} </p>
                            <p class="alert-subtitle"> {{alertDialogContents[alertType]?.subTitle}} </p>
                            <v-btn
                              class="btn primary-btn"
                              large
                              width="207px"
                              @click="closeAlert"
                              rounded
                              >Ok</v-btn
                            >
                          </v-card-text>
                        </v-container>
                      </v-card>
                    </v-dialog>
                    <v-dialog
                      v-model="sectionAlertDialog"
                      class="cdz"
                      max-width="624px"
                      min-height="303px"
                      persistent
                    >
                      <v-card>
                        <v-container fluid class="pa-4">
                          <v-card-text
                            class="text-center d-flex flex-column align-center"
                          >
                            <img src="../assets/warning.svg" />
                            <h2 class="pt-4">Error</h2>

                            <ul
                              class="text-left py-4 text-subtitle-1"
                              style="
                                list-style-type: disc;
                                padding-left: 1.5rem;
                              "
                            >
                              <li
                                v-for="(line, index) in sectionErrorLines"
                                :key="index"
                              >
                                {{ line }}
                              </li>
                            </ul>
                            <v-btn
                              class="btn primary-btn"
                              large
                              width="207px"
                              @click="closeSectionErrorDialog"
                              rounded
                              >Ok</v-btn
                            >
                          </v-card-text>
                        </v-container>
                      </v-card>
                    </v-dialog>

                    <v-dialog
                      v-model="headerError"
                      class="cdz"
                      max-width="424px"
                      min-height="303px"
                      persistent
                    >
                      <v-card>
                        <v-container fluid class="pa-8">
                          <v-card-text
                            class="text-center d-flex flex-column align-center"
                          >
                            <img src="../assets/warning.svg" />
                            <p class="text-h5 py-4">{{ errorMessage }}</p>
                            <v-btn
                              class="btn primary-btn"
                              large
                              width="207px"
                              @click="headerError = false"
                              rounded
                              >Ok</v-btn
                            >
                          </v-card-text>
                        </v-container>
                      </v-card>
                    </v-dialog>
                    <v-dialog
                      v-model="formatDialog"
                      class="cdz"
                      max-width="424px"
                      min-height="303px"
                      persistent
                    >
                      <v-card>
                        <v-container fluid class="pa-8">
                          <v-card-text
                            class="text-center d-flex flex-column align-center"
                          >
                            <img src="../assets/warning.svg" />
                            <p class="text-h5 py-4">{{ formatErrorMessage }}</p>
                            <v-btn
                              class="btn primary-btn"
                              large
                              width="207px"
                              @click="formatDialog = false"
                              rounded
                              >Ok</v-btn
                            >
                          </v-card-text>
                        </v-container>
                      </v-card>
                    </v-dialog>

                    <v-dialog
                      v-model="deleteDialog"
                      class="cdz"
                      max-width="400px"
                      min-height="294px"
                      persistent
                    >
                      <v-card>
                        <v-container fluid class="pa-2">
                          <v-card-text
                            class="text-center d-flex flex-column align-center"
                          >
                            <img src="../assets/done.svg" />
                            <p class="text-h5 py-4">
                              Question deleted Successfully
                            </p>

                            <v-btn
                              class="btn primary-btn w-100"
                              large
                              @click="removeSelectedQuestions"
                              rounded
                              >Ok</v-btn
                            >
                          </v-card-text>
                        </v-container>
                      </v-card>
                    </v-dialog>
                  </v-form>
                </v-stepper-content>
              </v-stepper-items>
            </v-card>
          </v-stepper>
        </v-card-text>

        <v-row
          align="center"
          class="d-flex justify-space-between pa-3 navigate-form-bar"
        >
          <v-btn
            v-if="e1 > 1 && e1 <= 2"
            outlined
            rounded
            class="btn outline-btn mx-2"
            @click="goBack"
          >
            Back
          </v-btn>
          <div class="d-flex ml-auto">
            <v-btn
              depressed
              class="btn outline-btn mx-2"
              large
              outlined
              rounded
              @click="cancelStaticAssessmentCreation"
            >
              Cancel
            </v-btn>
            <v-btn
              v-if="!isLastStep"
              :disabled="
                assessmentFormNotFilled || !isValid || !isValidDescription
              "
              rounded
              depressed
              class="btn tertiary-btn ml-2"
              @click="goto(e1)"
            >
              Next
            </v-btn>

            <v-btn
              v-if="isLastStep"
              rounded
              depressed
              color="btn primary-btn"
              class="ml-2 white--text"
              @click="goto(e1)"
              :loading="publishButtonLoader"
              :disabled="this.allQuestions <= 0"
            >
              {{ `${assessmentData.isEdit ? "Update" : "Create"}` }}
            </v-btn>
          </div>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import "../styles.css";
import AssessmentController from "@/controllers/AssessmentController";
import LevelController from "@/controllers/LevelController";
import GradeController from "@/controllers/GradeController";
import axios from "axios";
import Papa from "papaparse";
import TopicsController from "@/controllers/DemoTopicsController";
import AuthService from "../services/AuthService";
import RolesController from "@/controllers/RolesController";
import * as XLSX from "xlsx";
import StaticAssessmentController from "@/controllers/StaticAssessmentController";
import AudienceRolesController from "@/controllers/AudienceRolesController";
import SkillsController from "@/controllers/SkillsController";
import { mapGetters } from "vuex";
import UserNavMenu from "@/components/UserNavMenu.vue";
import { cloneDeep } from "lodash";
import isTableScrollableMixin from "@/mixins/isTableScrollableMixin";
import draggable from "vuedraggable";
import { sum } from "lodash";
export default {
  components: {
    UserNavMenu,
    draggable,
  },
  name: "CreateStaticAssessment",
  mixins: [ isTableScrollableMixin ],
  data() {
    // ...mapGetters
    return {
      preloader: false,
      roles: [],
      alertDialog: false,
      usersForRole: [],
      bulkTopicUploadResponse: [],
      fileName: "",
      approverData: {
        roleId: "",
        userId: "",
      },
      levels: [],
      groupNamesList: [],
      userTypeList: [],
      skillsList: [],
      assessmentCategoriesList: [],
      sectionsList: [],
      openApprovalDialogLoader: false,
      publishButtonLoader: false,
      draftButtonLoader: false,
      approvalDialog: false,
      sendForApprovalLoader: false,
      assessmentPublishedDialog: false,
      assessmentDraftDialog: false,
      defaultLanguages: ["English"],
      languageOptions: ["English", "Hindi", "Marathi"],
      assessmentData: {
        id: "",
        noOfQuestion: 0,
        availableLanguages: [],
        assessmentDescription: "",
        audienceRoleGroupId: "",
        assessmentUserType: "",
        skillIds: [],
        grades: [],
        sections: [],
        selectedSections: [],
        audienceRoleGroupId: "",
        assessmentCategory: "",
        level: "",
        assessmentName: "",
        modeOfAssessment: "Static Upload",
        isReshuffleRequired: "YES",
        isBioBreakIncluded: false,
        breakType: "",
        maxBreakDuration: null,
        questions: [],
        deletedQuestions: [],
        isEdit: false,
        questionsToUpload: [],
        timerType: "",
        totalDuration: null,
      },
      assessmentNameForDisplay: "",
      dialog: true,
      e1: 1,
      isDownloadtemplete: true,
      uploadingTopicsDialog: false,
      showConfirmDialog: false,
      displayQuestion: false,
      modeOfAssessmentList: ["Static Upload", "Dynamic Upload"],
      editorConfig: {},
      gradesList: [],
      bioBreakTypeList: ["Break Between Sections", "Break Anytime"],
      pageSize: 10,
      page: 1,
      dataTableOptions: {},
      selectedTableItems: [],
      questionsList: [],
      newquestionsList: [],
      newQuestionCount: 0,
      singleSelect: false,
      questionTypeList: [
        "SINGLE_CHOICE",
        "MULTIPLE_CHOICE",
        "FILL_IN_THE_BLANKS",
        "TRUE_FALSE",
        "MATCH_THE_FOLLOWING",
      ],
      bloomsTaxonomyLevel: [
        "REMEMBER",
        "UNDERSTAND",
        "APPLY",
        "ANALYZE",
        "EVALUATE",
        "CREATE",
      ],
      typeOfAudienceOptions: [
        { name: "Student" },
        { name: "Teacher" },
        { name: "Both" },
      ],
      authoredBy: null,
      authoredByOptions: [
        { name: "HubbleHox", value: "HubbleHox" },
        { name: "Vendor Acquired", value: "Vendor Acquired" },
        {
          name: "Acquired from Publications",
          value: "Acquired from Publications",
        },
        { name: "Acquired From Book", value: "Acquired From Book" },
        { name: "Practice guide", value: "Practice guide" },
        { name: "Ampersand", value: "Ampersand" },
        { name: "Vertex", value: "Vertex" },
      ],
      knowledgeLevels: ["MUST_KNOW", "SHOULD_KNOW", "NICE_TO_KNOW"],
      difficultyLevels: ["EASY", "MEDIUM", "HARD", "VERY_HARD"],
      complexityLevels: ["P1", "P2", "P3", "P4", "P5"],
      checkData: {
        skills: [],
        levels: [],
        grades: [],
        subjects: [],
      },
      removedQuestion: [],
      bulkQuestionJsonData: [],
      allQuestions: [],
      uniqueSkills: [],
      failedRows: [],
      failedRowCount: 0,
      successfullRowCount: 0,
      questionsToUpload: [],
      headers: [
        {
          text: "Question Id",
          align: "start",
          sortable: false,
          value: "questionId",
        },
        {
          text: "Question Statement",
          sortable: false,
          value: "questionStatement",
        },
        { text: "Question Type", sortable: false, value: "questionType" },
        { text: "Subject/Section", sortable: false, value: "subject" },
        { text: "Actions", sortable: false, value: "actions" },
      ],
      singleSelect: false,
      selectedQuestions: [],
      // addedQuestions: [],
      questionIds: [],
      englishCount: 0,
      mathCount: 0,
      logicalReasoningCount: 0,
      scienceCount: 0,
      totalMarks: 0,
      isAddMoreEnabled: false,
      deleteDialog: false,
      singleQuestionFailed: false,
      mandatoryFields: [
        "application",
        "questionId",
        "level",
        "grade",
        "skill",
        "setNumber",
        "hrisUniqueRole",
        "subject",
        "strand",
        "subStrand",
        "topic",
        "questionType",
        "languageOfQuestion",
        "questionStatement",
        "optionKey1",
        "optionKey2",
        "optionValue1",
        "optionValue2",
        "correctAnswer",
        "answerExplanation",
        "bloomsTaxonomy",
        "difficultyLevel",
        "authoredBy",
      ],
      headerError: false,
      errorMessage: null,
      formatDialog: false,
      formatErrorMessage: "",
      tablePageSize: 5,
      options: { page: 1, itemsPerPage: 10 },
      uploadingQuestions: false,
      groupNameForDisplay: "",
      skillNames: [],
      categoryNameForDisplay: "",
      successIcon: require("../assets/success.svg"),
      isValid: true,
      isDurationValid: true,
      isValidNoOfQuestions: true,
      ckEditorError: "",
      isValidDescription: true,
      assessmentDescriptionLength: 0,
      maxAssessmentDescriptionLength: 500,
      sectionAlertDialog: false,
      sectionErrorMessage: "",
      selectedGrade: "",
      assessmentSectionId: "",
      secondLoader: false,
      alertDialogContents : {
        'countMismatch': {
          icon: require('../assets/warning.svg'),
          title: 'Questions count mismatch',
          subTitle: ''
        },
        'sequenceMismatch' : {
          icon: require('../assets/uploadWarning.svg'),
          title: 'Sequence Mismatch',
          subTitle: 'Please update the sequence of the selected dimensions or modify the sequence in the uploaded Excel file.'
        },
      },
      alertType: '',
    };
  },

  watch: {
    dataTableOptions: {
      handler() {
        console.log("dataTableOptions entered", this.dataTableOptions);
        this.pageSize = this.dataTableOptions.itemsPerPage;
        this.page = this.dataTableOptions.page;
        let len =
          Number(Number(this.page ?? 1) * Number(this.pagesize ?? 10)) - 9;
        this.newquestionsList = [];
        let size = Number(Number(this.page ?? 1) * Number(this.pagesize ?? 10));
        console.log(
          "len",
          len,
          "size",
          size,
          "this.questionsList.length",
          this.questionsList.length
        );
        for (let i = len; i < size; i++) {
          if (len <= this.questionsList.length) {
            this.newquestionsList.push(this.questionsList[i]);
          }
        }
      },
      deep: true,
    },
  },

  methods: {
    redirectToViewQuestion(questionId) {
      this.assessmentData["skills"] = this.skillNames;
      this.$store.dispatch("setAssessmentData", this.assessmentData);
      let question = this.assessmentData?.questions.find(
        (question) => question.questionId == questionId
      );
      this.$router.push({
        path: "/assessment-listing-question",
        query: { questionId: questionId },
      });
    },
    allowPositiveNumbers(event, index, key, { allowDecimals = false } = {}) {
      const val = Number(event);
      if (val < 0) {
        this.$nextTick(() => {
          this.assessmentData.sections[index][key] = 0;
        });
      } else if (!allowDecimals && !Number.isInteger(val)) {
        this.$nextTick(() => {
          this.assessmentData.sections[index][key] = Math.floor(val);
        });
      }
    },
    restrictToPositiveIntegers(event, key) {
      if (Number(event) < 1) {
        this.$nextTick(() => {
          this.assessmentData[key] = null;
        });
      }
    },
    handleChange(audienceRoleGroupId) {
      this.getUserTypeForGroupName(audienceRoleGroupId);
      this.getLevels();
      this.getGradesMappedToLevels();
      this.clearQuestions();
    },
    validateAssessmentName() {
      const isAssessmentName =
        this.assessmentData.assessmentName !== "" &&
        this.assessmentData.assessmentName !== null &&
        this.assessmentData.assessmentName.length <= 100;
      this.isValid = isAssessmentName;
    },
    // validateDuration(){
    //   console.log('validateDuration')
    //   const isDuration =
    //     this.section.duration !== '' &&
    //     this.section.duration !== null &&
    //     Number(this.section.duration) > 0 &&
    //     Number.isInteger(Number(this.section.duration));
    //     this.isDurationValid = isDuration;

    // },
    // validateNoOfQuestions(){
    //   console.log('validateNoOfQuestions')
    //   const isnoOfQuestions =
    //     this.section.noOfQuestions !== '' &&
    //     this.section.noOfQuestions !== null &&
    //     Number(this.section.noOfQuestions) > 0 &&
    //     Number.isInteger(Number(this.section.noOfQuestions));
    //     this.isValidNoOfQuestions = isnoOfQuestions;

    // },
    validateDescription() {
      const isDescriptionValid = !this.ckEditorError;

      this.isValidDescription = isDescriptionValid;
    },
    displaySubjectsOrSections(item) {
      const hasValidArray = (arr) =>
        Array.isArray(arr) && arr.length > 0 && arr.some((val) => val !== "NA");

      const hasValidString = (str) =>
        typeof str === "string" && str.trim() !== "" && str !== "NA";

      if (hasValidArray(item.subject)) {
        return item.subject.filter((val) => val !== "NA").join(", ");
      } else if (hasValidString(item.strand)) {
        return item.strand;
      } else {
        return "NA";
      }
    },
    clearQuestions() {
      this.allQuestions = [];
    },
    stripHtml(html) {
      const div = document.createElement("div");
      div.innerHTML = html;
      return div.textContent || div.innerText || "";
    },
    validateEditorContent() {
      const plainText = this.stripHtml(
        this.assessmentData.assessmentDescription
      );
      this.assessmentDescriptionLength = plainText.trim().length;

      if (!this.assessmentDescriptionLength) {
        this.ckEditorError = "Assessment Description is required";
        this.isValidDescription = false;
      } else if (
        this.assessmentDescriptionLength > this.maxAssessmentDescriptionLength
      ) {
        this.ckEditorError = `Maximum ${this.maxAssessmentDescriptionLength} characters allowed`;
        this.isValidDescription = false;
      } else {
        this.ckEditorError = "";
        this.isValidDescription = true;
      }
    },
    onEditorInput() {
      this.validateEditorContent();
    },
    clearDataAndClose() {
      this.uploadingTopicsDialog = false;
      this.failedRows = [];
    },
    onFooterUpdate(newOptions) {
      this.options = { ...this.options, ...newOptions };
    },
    handleInputNumber(event) {
      const value = this.assessmentData.noOfQuestion;
      if (
        parseInt(value) <= 0 ||
        value.indexOf(".") > -1 ||
        value.indexOf("e") > -1
      ) {
        this.assessmentData.noOfQuestion = 1;
      }
      this.handleInputChange();
    },
    handleInputChange() {
      // Reset allQuestions whenever the input changes
      this.allQuestions = [];
      this.totalMarks = 0;
      this.scienceCount = 0;
      this.logicalReasoningCount = 0;
      this.englishCount = 0;
      this.mathCount = 0;
      // Reset allQuestions whenever the input changes
    },
    openCountErrorDialog(alertType) {
      this.alertType = alertType;
      this.alertDialog = true;
    },
    openSectionErrorDialog() {
      this.sectionAlertDialog = true;
    },
    closeSectionErrorDialog() {
      this.sectionAlertDialog = false;
    },
    closeAlert() {
      this.alertDialog = false;
    },
    logout() {
      AuthService.logout();
      this.$router.push("/login");
    },
    removeSelectedQuestions() {
      this.assessmentData.deletedQuestions = this.selectedQuestions.map(
        (question) => question.questionId
      );
      this.allQuestions = this.removeQuestionIdsFrom(
        this.allQuestions,
        this.assessmentData.deletedQuestions
      );
      this.questionsToUpload = this.removeQuestionIdsFrom(
        this.questionsToUpload,
        this.assessmentData.deletedQuestions
      );
      this.bulkQuestionJsonData = this.removeQuestionIdsFrom(
        this.bulkQuestionJsonData,
        this.assessmentData.deletedQuestions
      );
      this.assessmentData.questions = this.removeQuestionIdsFrom(
        this.assessmentData.questions,
        this.assessmentData.deletedQuestions
      );
      this.getSubjectCount();
      this.calculateTotalMarks();
      this.selectedQuestions = [];
      this.deleteDialog = false;
    },
    removeQuestionIdsFrom(questionsList, questionIdsTobeRemoved) {
      return questionsList.filter(
        (question) => !questionIdsTobeRemoved.includes(question.questionId)
      );
    },
    getGradesMappedToLevels(event, isRehydratingForm = false) {
      // Trigger fetchSections if a grade is already selected
      if (!isRehydratingForm && this.assessmentData.grades && this.assessmentData.skillIds) {
        this.assessmentData.sections = [];
        this.sectionsList = [];
      }
      if (!isRehydratingForm) {
        this.gradesList = [];
        // const { level } = this.assessmentData;
        // const levelGradeMap = {
        //   Middle: 'Grade 8',
        //   Secondary: 'Grade 10',
        // };

        // this.selectedGrade = levelGradeMap[level] || '';
        // if(this.selectedGrade !== '')this.assessmentData.grades = [this.selectedGrade];
        // console.log('this.assessmentData.grades.length ', this.assessmentData.grades.length );
        // if(this.assessmentData.grades.length !== 0) this.fetchSections();
      }
      this.levels.forEach((level) => {
        if (this.assessmentData.level == level.name) {
          this.gradesList.push(...level.grades);
        }
      });
    },
    async getLevels() {
      this.assessmentData.level = "";
      const response = await LevelController.getLevelByGroupName(
        this.assessmentData.audienceRoleGroupId
      );
      if (response.status == 200) {
        if (response.data.levels.length > 0) {
          this.levels = response.data.levels;
        } else {
          this.levels = [];
        }
      }
    },
    getUniqueSubjects() {
      const uniqueSubjects = new Set(); // To store unique subjects

      this.allQuestions.forEach((item) => {
        if (item.subject.length > 0) {
          uniqueSubjects.add(item.subject[0]); // Add the first element of the subject array to the set
        }
      });

      return Array.from(uniqueSubjects); // Convert Set to Array and return
    },
    getUniqueSkills() {
      const uniqueSkills = new Set(); // To store unique subjects

      this.allQuestions.forEach((item) => {
        uniqueSkills.add(item.skill); // Add subject to the set
      });

      return Array.from(uniqueSkills); // Convert Set to Array and return
    },
    async createStaticAssessment(assessment, status) {
      this.publishButtonLoader = status == "PUBLISHED";
      this.draftButtonLoader = status == "DRAFT";
      // let uniquesSubjects = this.getUniqueSubjects();
      // let uniqueSkills = this.getUniqueSkills();
      let questions = this.assessmentData.isEdit
        ? [...this.assessmentData.questions, ...this.questionsToUpload]
        : this.questionsToUpload;

      const isSelectiveTimer = this.assessmentData.timerType === "Selective Section Timer";
      const sanitizedSections = (assessment.sections || []).map((section) => {
        if (isSelectiveTimer) {
          return {
            ...section,
            isTimedSection: !!section.isTimedSection,
            breakDuration: Number(section.breakDuration) || 0,
          };
        }
        // eslint-disable-next-line no-unused-vars
        const { isTimedSection, breakDuration, ...rest } = section;
        return rest;
      });

      let assessmentDraftData = {
        id: assessment.id,
        assessmentName: assessment.assessmentName || "Untitled",
        audienceRoleGroupId: assessment.audienceRoleGroupId || "",
        assessmentUserType: assessment.assessmentUserType || "",
        skills: this.skillNames || [],
        sections: sanitizedSections,
        assessmentCategory: assessment.assessmentCategory || "",
        modeOfAssessment: assessment.modeOfAssessment || "",
        assessmentDescription: assessment.assessmentDescription || "",
        status: status,
        availableLanguages: assessment.availableLanguages || "",
        isReshuffleRequired: assessment.isReshuffleRequired || true,
        isBioBreakIncluded: assessment.isBioBreakIncluded || false,
        ...(assessment.isBioBreakIncluded && {
          breakType: assessment.breakType || "",
        }),
        ...(assessment.isBioBreakIncluded && {
          maxBreakDuration: Number(assessment.maxBreakDuration) || 0,
        }),
        level: assessment.level || "",
        grades: assessment.grades || [],
        noOfQuestion: this.totalQuestions || 0,
        duration: this.assessmentData?.totalDuration || 0,
        timerType: this.assessmentData.timerType || "",
        questions: questions,
        // subjects: uniquesSubjects,
        marksAllotted: this.totalMarks,
        // skills: uniqueSkills, //depends on uploaded questions csv
        isSoftDeleted: false,
        deletedQuestions: this.assessmentData.isEdit
          ? this.assessmentData.deletedQuestions
          : [],
        totalQuestionsUploaded: questions.length || 0,
        isQuestionUploaded: questions.length > 0,
      };
      console.log("assessmentDraftData", assessmentDraftData);
      let response = await StaticAssessmentController.createStaticAssessment(
        assessmentDraftData
      );
      if (response.data.flag) {
        this.assessmentPublishedDialog = status == "PUBLISHED";
        this.assessmentDraftDialog = status == "DRAFT";
        this.publishButtonLoader = false;
        this.draftButtonLoader = false;
      }
      // truncating relevant states of vuex store on completion of assessment creation flow
      this.$store.dispatch("setQuestionForEdit", {});
      this.$store.dispatch("setAssessmentData", {});
    },
    cancelStaticAssessmentCreation() {
      // truncating relevant states of vuex store on completion of assessment creation flow
      this.$store.dispatch("setQuestionForEdit", {});
      this.$store.dispatch("setAssessmentData", {});

      this.$router.replace("/static-assessment");
    },
    closeApprovalDialog() {
      this.approvalDialog = false;
      for (const key in this.approverData) {
        this.approverData[key] = "";
      }
    },
    sendForApproval() {
      console.log(this.approverData);
      alert("{send for approval} function call here");
      //function to be deleted on dev complete
      //logic for sendForApprovalLoader to be added
    },
    async getRoles() {
      const response = await RolesController.getRoles();
      if (response.data.flag) {
        this.roles = response.data.data.filter(
          (role) =>
            role.assessment.admin == false && role.assessment.read == true
        );
        this.openApprovalDialogLoader = false;
        if (this.e1 == 2) this.approvalDialog = true;
      } else {
        alert("Some thing went wrong while fetching all roles");
      }
    },
    getUsersForRole(roleId) {
      this.approverData.userId = "";
      this.usersForRole = this.roles.find((role) => role.id == roleId).users;
    },
    // async getGrades() {
    //   const response = await GradeController.getAllGrades();
    //     console.log("resss",response)
    //   if (response.status == 200) {
    //     if (response.data.grades.length > 0) {
    //       // this.gr = response.data.grades;
    //       this.grades = await response.data.grades.map((e) => e.name);
    //     } else {
    //       this.grades = [];
    //     }
    //   } else {
    //     alert(response.data.error);
    //   }
    //   // console.log("level data", this.levelData.rows);
    // },
    displayQuestionList() {
      this.displayQuestion = true;
      this.showConfirmDialog = false;
      this.isDownloadtemplete = false;
    },
    onCancel() {
      this.questionIds = [];
      this.failedRows = [];
      this.successfullRowCount = 0;
      this.failedRowCount = 0;
      this.uploadingTopicsDialog = false;
      this.singleQuestionFailed = false;
    },
    async uploadConfirm() {
      this.uploadingQuestions = true;

      this.bulkQuestionJsonData = this.transformQuestions(
        this.bulkQuestionJsonData
      );
      await this.resolveQuestionsMedia(
        this.bulkQuestionJsonData,
        this.assessmentData.availableLanguages
      );
      this.questionsToUpload.push(...this.bulkQuestionJsonData);

      this.allQuestions.push(
        ...this.getQuestionsForLanguage("English", this.bulkQuestionJsonData)
      );

      this.uploadingQuestions = false;
      this.uploadingTopicsDialog = false;
      this.showConfirmDialog = true;

      this.getSubjectCount();
      this.calculateTotalMarks();
      this.failedRows = [];
      this.failedRowCount = 0;
    },
    getSubjectCount() {
      this.englishCount = this.countBySubject("English");
      console.log("this.englishCount", this.englishCount);
      this.mathCount = this.countBySubject("Mathematics");
      this.logicalReasoningCount = this.countBySubject("Logical Reasoning");
      this.scienceCount = this.countBySubject("Science");
    },
    calculateTotalMarks() {
      this.totalMarks = this.allQuestions.reduce((sum, question) => {
        console.log("total ques", question.languageOfQuestion);
        const marks =
          question.marksAllotted === "NA" ? 1 : Number(question.marksAllotted);
        return sum + marks;
        return sum; // Always return the current sum
      }, 0);

      console.log("Total Marks:", this.totalMarks);
    },
    countBySubject(subject) {
      const uniqueQuestions = new Set(); // To store unique question IDs

      this.allQuestions.forEach((item) => {
        if (item.subject.includes(subject)) {
          uniqueQuestions.add(item.questionId); // Add questionId to the set
        }
      });

      return uniqueQuestions.size; // Return the count of unique questions
    },
    async downloadTemplate() {
      try {
        const fileUrl =
          "https://firebasestorage.googleapis.com/v0/b/vgos-sss-stag.appspot.com/o/csv_templates%2FnewquestionUpload%20(1).csv?alt=media&token=7705b25b-bda3-409f-ba09-2149712f0fb1";
        const response = await axios({
          url: fileUrl,
          method: "GET",
          responseType: "blob", // Ensure response is treated as a Blob
        });

        // Create a temporary URL for the Blob
        const blobUrl = window.URL.createObjectURL(
          new Blob(["\uFEFF", response.data], {
            type: "text/csv;charset=utf-8;",
          })
        );

        // Create a link element
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", "downloaded_file.csv"); // Set desired filename

        // Append the link to the body
        document.body.appendChild(link);

        // Trigger the click event on the link to initiate download
        link.click();

        // Clean up: remove the link and revoke the Blob URL
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error("Error downloading file:", error);
      }
    },
    selectFile() {
      // Trigger the file input click
      this.$refs.fileInput.click();

      this.isAddMoreEnabled = true;
    },
    handleFileUpload(event) {
      console.log("handle File upload");
      const file = event.target.files[0];
      if (file) {
        // Check for CSV format
        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (fileExtension !== "csv") {
          this.formatDialog = true;
          this.formatErrorMessage =
            "Incorrect file format selected. Please upload a CSV file";
          // this.openErrorDialog('Incorrect file format selected. Please upload a CSV file.');
          // return; // Exit the function if the format is incorrect
        } else {
          if (this.assessmentData.modeOfAssessment == "Static Upload") {
            this.csvFileToJSONStaticUpload(file);
          } else if (this.assessmentData.modeOfAssessment == "Dynamic Upload") {
            this.csvFileToJSONDynamicUpload(file);
          }
        }
        // Reset the input value
        event.target.value = ""; // Allow the same file to be selected again
      }
    },

    csvFileToJSONStaticUpload(file) {
      console.log("file", file.name);

      var contents = [];
      this.fileName = file.name;

      try {
        Papa.parse(file, {
          header: false,
          skipEmptyLines: true,
          complete: function (results) {
            this.content = results;
            this.parsed = true;
            contents = this.content.data;
            if (contents.length < 1) {
              this.errorMessage =
                "Please upload a file that contains at least one question. Empty files are not allowed.";
              this.headerError = true;
            }
            var totalRowCount = contents.length - 1;

            var jsonData = [];
            var removedQuestion = [];
            var headers = contents[0];

            const isValidateError = this.validateHeaders(headers);
            this.successfullRowCount = 0;
            this.failedRowCount = 0;
            const englishQuestionsMap = new Map();

            if (contents.length < 2) {
              this.errorMessage =
                "Please upload a file that contains at least one question. Empty files are not allowed.";
              this.headerError = true;
            } else if (isValidateError) {
              this.headerError = true;
            } else if (
              !this.isAddMoreEnabled &&
              totalRowCount !== this.totalQuestions
            ) {
              this.openCountErrorDialog('countMismatch');
            } else if (
              this.isAddMoreEnabled &&
              totalRowCount +
                this.allQuestions.length *
                  this.assessmentData.availableLanguages.length !==
                this.totalQuestions
            ) {
              this.openCountErrorDialog('countMismatch');
            } else {
              // Section validation before processing individual rows
              const sectionCounts = {};
              const strandIndex = headers.indexOf("strand");

              for (let i = 1; i < contents.length; i++) {
                const row = contents[i];
                const strandValue = row[strandIndex]?.trim();

                if (strandValue) {
                  sectionCounts[strandValue] =
                    (sectionCounts[strandValue] || 0) + 1;
                }
              }

              let sectionMismatch = false;
              let sectionErrorMessages = [];

              this.assessmentData.sections.forEach((section) => {
                const expected =
                  section.noOfQuestions *
                  this.assessmentData.availableLanguages.length;

                const actual = sectionCounts[section.name] || 0;

                if (expected != actual) {
                  sectionMismatch = true;
                  sectionErrorMessages.push(
                    `Section '${section.name}' requires ${expected} question(s), but found ${actual} in the uploaded CSV.`
                  );
                }
              });

              if (sectionMismatch) {
                this.sectionErrorMessage = sectionErrorMessages.join("\n");
                this.openSectionErrorDialog();
                return;
              }

              const requiredLanguage = this.assessmentData.availableLanguages;
              const grades = this.assessmentData.grades;
              const questionLanguageMap = {};
              const questions = {};

              const mandatoryFields = [
                "application",
                "questionId",
                "level",
                "grade",
                "skill",
                "setNumber",
                "hrisUniqueRole",
                "subject",
                "strand",
                "subStrand",
                "topic",
                "questionType",
                "languageOfQuestion",
                "questionStatement",
                "options",
                "loCode1",
                "loCode2",
                "loCode3",
                "loCode4",
                "answerExplanation",
                "bloomsTaxonomy",
                "difficultyLevel",
                "authoredBy",
                "markingType",
                "groupName",
              ];

              for (let i = 1; i < contents.length; i++) {
                let rowData = {};
                let options = [];
                let cells = contents[i];
                let failureReason = [];

                let questionId = "";
                let languageOfQuestion = "";
                let subject = "";

                headers.forEach((header, index) => {
                  if (header.trim() === "questionId") {
                    questionId = cells[index]?.trim() || "";
                  } else if (header.trim() === "languageOfQuestion") {
                    languageOfQuestion = cells[index]?.trim() || "";
                  } else if (header.trim() === "subject") {
                    subject = cells[index]?.trim() || "";
                  }
                });

                if (!questions[questionId]) {
                  questions[questionId] = new Set();
                }

                if (languageOfQuestion) {
                  questions[questionId].add(languageOfQuestion);
                }

                const questionLangKey = `${questionId}|${languageOfQuestion}`;
                if (!questionLanguageMap[questionLangKey]) {
                  questionLanguageMap[questionLangKey] = 0;
                }

                const missingFields = mandatoryFields.filter((field) => {
                  const index = headers.indexOf(field);
                  return (
                    index !== -1 &&
                    (!cells[index] || cells[index].trim() === "")
                  );
                });

                if (missingFields.length > 0) {
                  if (!removedQuestion.includes(i)) {
                    removedQuestion.push(i);
                  }
                  failureReason.push(
                    `A mandatory field ('${missingFields.join(
                      ", "
                    )}') has no value. Please provide the necessary input.`
                  );
                  this.skippedQuestion(i, failureReason);
                }

                let markingType = "";
                let questionType = null;

                for (let j = 0; j < cells.length; j++) {
                  let rawHeader = headers[j];
                  let header = rawHeader?.trim().replace("*", "");
                  if (!header) {
                    continue; // Skip empty header columns to avoid "" keys
                  }
                  const value = cells[j]?.trim() || "";

                  // if (mandatoryFields.includes(header)) {
                  rowData[header] = value;
                  // }

                  if (header === "markingType") {
                    if (
                      value === "Regular Marking" ||
                      value === "Likert Marking"
                    ) {
                      markingType = value;
                      rowData[header] = value;
                    } else {
                      if (!removedQuestion.includes(i)) {
                        removedQuestion.push(i);
                      }
                      failureReason.push(
                        "The marking type provided is invalid. Please ensure you are using a supported marking type (e.g., Regular, Likert)."
                      );
                      this.skippedQuestion(i, failureReason);
                    }
                  }

                  if (header.includes("languageOfQuestion")) {
                    if (!requiredLanguage.includes(value)) {
                      if (!removedQuestion.includes(i)) {
                        removedQuestion.push(i);
                      }
                      failureReason.push(
                        "The language you've selected was not configured during the creation of the assessment. Please use a valid language."
                      );
                      this.skippedQuestion(i, failureReason);
                      continue;
                    }
                  }

                  if (header == "skill" && value !== this.skillNames[0]) {
                    if (!removedQuestion.includes(i)) {
                      removedQuestion.push(i);
                    }
                    failureReason.push(
                      "The skill you selected was not defined during assessment creation. Kindly select from the predefined skill list."
                    );
                    this.skippedQuestion(i, failureReason);
                  }
                  if (
                    header === "skill" &&
                    value.toLowerCase() === "psychometry"
                  ) {
                    const setNumberIndex = headers.indexOf("setNumber");
                    const setNumberValue = cells[setNumberIndex]?.trim() || "";
                    const strandIndex = headers.indexOf("strand");
                    const strandValue = cells[strandIndex]?.trim() || "";

                    const substrandIndex = headers.indexOf("subStrand");
                    const substrandValue = cells[substrandIndex]?.trim() || "";
                    const isInvalidSetNumber =
                      !setNumberValue || setNumberValue.toUpperCase() === "NA";
                    const isInvalidStrand =
                      !strandValue || strandValue.toUpperCase() === "NA";
                    const isInvalidSubstrand =
                      !substrandValue || substrandValue.toUpperCase() === "NA";

                    const subjectIndex = headers.indexOf("subject");
                    const subjectValue = cells[subjectIndex]?.trim() || "";
                    const isSubjectValid = subjectValue.toUpperCase() === "NA";
                    if (
                      isInvalidSetNumber ||
                      isInvalidStrand ||
                      isInvalidSubstrand
                    ) {
                      if (!removedQuestion.includes(i)) {
                        removedQuestion.push(i);
                      }
                      failureReason.push(
                        "For the skill 'Psychometry', the fields 'setNumber', 'strand', and 'substrand' must not be empty or marked as 'NA'"
                      );
                      this.skippedQuestion(i, failureReason);
                    }
                    if (strandValue != "NA") {
                      const sectionExists = this.assessmentData.sections.some(
                        (section) => section.name === strandValue
                      );
                      if (!sectionExists) {
                        if (!removedQuestion.includes(i)) {
                          removedQuestion.push(i);
                        }
                        failureReason.push(
                          `The provided strand value '${strandValue}' is not included in the dimensions/ sections selected during assessment creation`
                        );
                        this.skippedQuestion(i, failureReason);
                      }
                    }

                    if (!isSubjectValid) {
                      if (!removedQuestion.includes(i)) {
                        removedQuestion.push(i);
                      }
                      failureReason.push(
                        "When the skill is 'Psychometry', the 'subject' field should be marked as 'NA'."
                      );
                      this.skippedQuestion(i, failureReason);
                    }
                  } else if (
                    header === "skill" &&
                    value.toLowerCase() === "Core Skill"
                  ) {
                    const strandIndex = headers.indexOf("strand");
                    const strandValue = cells[strandIndex]?.trim() || "";

                    const substrandIndex = headers.indexOf("substrand");
                    const substrandValue = cells[substrandIndex]?.trim() || "";

                    const subjectIndex = headers.indexOf("subject");
                    const subjectValue = cells[subjectIndex]?.trim() || "";

                    const isStrandValid =
                      strandValue && strandValue.toUpperCase() !== "NA";
                    const isSubstrandValid =
                      substrandValue && substrandValue.toUpperCase() !== "NA";
                    const isSubjectValid =
                      subjectValue && subjectValue.toUpperCase() !== "NA";

                    if (
                      !isStrandValid ||
                      !isSubstrandValid ||
                      !isSubjectValid
                    ) {
                      removedQuestion.push(i);
                      failureReason.push(
                        "For 'core skill', 'strand' and 'substrand' must not be empty or 'NA', and 'subject' must be provided and not 'NA'"
                      );
                      this.skippedQuestion(i, failureReason);
                    }
                  }
                  if (header === "grade") {
                    if (!grades.includes(value)) {
                      removedQuestion.push(i);
                      failureReason.push(
                        "The grade mentioned in this row does not match the grade selected when the assessment was created."
                      );
                      this.skippedQuestion(i, failureReason);
                    }
                    rowData[header] =
                      value.startsWith("Grade ") || value === "NA"
                        ? value
                        : `Grade ${value}`;
                    continue;
                  }

                  if (
                    header === "groupName" &&
                    value != this.groupNameForDisplay
                  ) {
                    if (!removedQuestion.includes(i)) {
                      removedQuestion.push(i);
                    }
                    failureReason.push(
                      "The groupName mentioned in this row does not match the groupName selected when the assessment was created."
                    );
                    this.skippedQuestion(i, failureReason);
                  }

                  if (
                    header === "difficultyLevel" ||
                    header === "complexityLevel"
                  ) {
                    rowData[header] = value.toUpperCase();
                    continue;
                  }

                  if (header === "proficiencyLevel") {
                    rowData[header] = value.toUpperCase();
                    continue;
                  }

                  if (header.startsWith("optionKey")) {
                    options.push({ optionKey: value });
                  }

                  if (
                    header.startsWith("optionValue") &&
                    value.includes("https://drive.google.com/file/")
                  ) {
                    const found = value.match(/\/d\/([A-Za-z0-9-_]+)/);
                    const transformedValue =
                      found && found[1]
                        ? `https://drive.google.com/uc?export=view&id=${found[1]}`
                        : value;
                    const lastOptionIndex = options.length - 1;
                    if (lastOptionIndex >= 0) {
                      options[lastOptionIndex].optionValue = transformedValue;
                    }
                  } else if (header.startsWith("optionValue")) {
                    const lastOptionIndex = options.length - 1;
                    if (lastOptionIndex >= 0) {
                      options[lastOptionIndex].optionValue = value;
                    }
                  }

                  if (header === "questionType") {
                    questionType = value;
                  }

                  if (header === "subject") {
                    rowData[header] = value.split(",").map((s) => s.trim());
                  }
                }

                // Handle Likert Marking Rules
                if (markingType === "Likert Marking") {
                  if (
                    rowData["marksAllotted"] !== "NA" ||
                    rowData["correctAnswer"] !== "NA"
                  ) {
                    if (!removedQuestion.includes(i)) {
                      removedQuestion.push(i);
                    }

                    let reason = "";
                    if (rowData["marksAllotted"] !== "NA") {
                      reason +=
                        ' For Likert marking type, Marks Allotted must be "NA". ';
                    }
                    if (rowData["correctAnswer"] !== "NA") {
                      reason +=
                        'For Likert marking type, Correct Answer must be "NA".';
                    }

                    failureReason.push(reason.trim());
                    this.skippedQuestion(i, failureReason);

                    // Set marksAllotted to 'NA'
                    rowData["marksAllotted"] = 0;
                    rowData["correctAnswer"] = "NA";
                  }
                  // Validate each option has corresponding score
                  options = options.map((opt, idx) => {
                    const scoreIndex = headers.indexOf(`optionScore${idx + 1}`);
                    const scoreValue =
                      scoreIndex !== -1 ? cells[scoreIndex]?.trim() : "";

                    const isNumeric =
                      scoreValue !== "" &&
                      scoreValue.toUpperCase() !== "NA" &&
                      !isNaN(scoreValue);

                    if (!isNumeric) {
                      opt.optionScore = "";
                      if (!removedQuestion.includes(i)) {
                        removedQuestion.push(i);
                      }
                      failureReason.push(
                        `For Likert marking type, each option must have a valid numeric optionScore — option ${opt.optionKey} has an invalid or missing score (must not be empty, 'NA', or non-numeric).`
                      );
                      this.skippedQuestion(i, failureReason);
                    } else {
                      opt.optionScore = scoreValue;
                    }

                    return opt;
                  });

                  // Ensure questionType is only SINGLE_CHOICE
                  // if (questionType && questionType !== 'SINGLE_CHOICE') {
                  //   if (!removedQuestion.includes(i)) {
                  //     removedQuestion.push(i);
                  //   }
                  //     failureReason.push('Likert-type questions must be configured as SINGLE_CHOICE.');
                  //     this.skippedQuestion(i, failureReason);

                  // }
                } else {
                  if (
                    rowData["marksAllotted"] === "NA" ||
                    rowData["marksAllotted"] === "" ||
                    rowData["correctAnswer"] === "NA" ||
                    rowData["correctAnswer"] === ""
                  ) {
                    if (!removedQuestion.includes(i)) {
                      removedQuestion.push(i);
                    }
                    failureReason.push(
                      "Since this question is marked for Regular marking type, both Marks Allotted and Correct Answer fields must have valid values provided."
                    );
                    this.skippedQuestion(i, failureReason);
                  }
                  // For regular markingType, set optionScore = 'NA' for all options
                  options = options.map((opt, idx) => {
                    const scoreIndex = headers.indexOf(`optionScore${idx + 1}`);
                    const scoreValue =
                      scoreIndex !== -1 ? cells[scoreIndex]?.trim() : "";

                    if (scoreValue !== "NA") {
                      if (!removedQuestion.includes(i)) {
                        removedQuestion.push(i);
                      }
                      failureReason.push(
                        `For Regular marking type, the optionScore for option ${opt.optionKey} should be set to 'NA'.`
                      );
                      this.skippedQuestion(i, failureReason);
                    }

                    return {
                      ...opt,
                      optionScore: "NA",
                    };
                  });
                }
                if (rowData["questionType"] === "MATCH_THE_FOLLOWING") {
                  rowData["mtfOptions"] = this.prepareOptions(
                    rowData["correctAnswer"]
                  );
                } else {
                  rowData["questionOptions"] = this.getOptions(
                    rowData["questionType"],
                    options
                  );
                }

                questionLanguageMap[questionLangKey]++;
                if (questionLanguageMap[questionLangKey] > 1) {
                  failureReason.push(
                    "The question ID already exists elsewhere in the same sheet. Each question must have a unique ID."
                  );
                  removedQuestion.push(i);
                }
                console.log("failureReason", failureReason);
                if (i !== 0) {
                  const combinedFailureReason = failureReason.join(", ");
                  if (!removedQuestion.includes(i)) {
                    jsonData.push(rowData);
                    this.successfullRowCount++;
                  } else {
                    this.failedRows.push({
                      ...rowData,
                      Reason: combinedFailureReason,
                    });
                    this.failedRowCount++;
                  }
                }

                if (
                  totalRowCount === 3 &&
                  questions[questionId].size > 1 &&
                  this.failedRowCount > 0
                ) {
                  // this.singleQuestionFailed = true;
                }
              }

              const mergedData = [...jsonData, ...this.failedRows];
              this.validateLanguages(mergedData, requiredLanguage);

              this.bulkQuestionJsonData = jsonData.filter(
                (question) => !this.questionIds.includes(question.questionId)
              );

              if(!this.validateUploadSequence() && this.assessmentData?.timerType === "Selective Section Timer"){
                this.openCountErrorDialog('sequenceMismatch');
                return;
              }
              this.uploadTopics();
            }
          }.bind(this),
        });
      } catch (e) {
        console.error(e);
      }
    },
    csvFileToJSONDynamicUpload() {},

    normalizeField(field) {
      return field
        .replace(/[*]/g, "") // remove asterisks
        .replace(/([a-z])([A-Z])/g, "$1 $2") // convert camelCase to space-separated
        .replace(/\s+/g, " ") // replace multiple spaces with a single space
        .trim()
        .toLowerCase();
    },
    validateHeaders(headers) {
      console.log("headers", headers);
      console.log("this.mandatoryFields", this.mandatoryFields);
      const normalizedHeaders = headers.map((h) => this.normalizeField(h));
      const missingFields = this.mandatoryFields.filter(
        (field) => !normalizedHeaders.includes(this.normalizeField(field))
      );
      console.log("missingFields", missingFields);

      if (missingFields.length > 0) {
        this.errorMessage = "Few headers are incorrect";
        return true;
      } else {
        console.log("All mandatory headers are present.");
      }
    },

    validateLanguages(jsonData, requiredLanguage) {
      const groupedQuestions = {};

      // Step 2: Group questions by questionID and collect unique questionIDs
      jsonData.forEach((question) => {
        if (!groupedQuestions[question.questionId]) {
          groupedQuestions[question.questionId] = [];
          // this.questionIds.push(question.questionId); // Add questionID to the array
        }
        groupedQuestions[question.questionId].push(question);
      });

      // Step 2: Check for missing languages and collect the required question objects

      for (const questionId in groupedQuestions) {
        const questions = groupedQuestions[questionId];

        const languagesAvailable = this.assessmentData.availableLanguages;
        const subject = questions[0].subject;

        if (subject.includes("English")) {
          continue; // Skip validation for this questionId
        }

        // Find missing languages

        const missingLanguages = requiredLanguage.filter(
          (lang) => !languagesAvailable.includes(lang)
        );

        if (missingLanguages.length > 0) {
          groupedQuestions[questionId].forEach((question) => {
            // Append the reason for missing languages

            if (!this.questionIds.includes(question.questionId)) {
              this.questionIds.push(question.questionId);
            }
            this.failedRows.push({
              ...question,
              reason: `Uploading questions in ${missingLanguages.join(
                ", "
              )} is mandatory`,
            });
            this.successfullRowCount--;
            this.failedRowCount++; // Increment failedRowCount
          });
        }
      }
    },
    downloadFailedRows() {
      // Create a new workbook
      const wb = XLSX.utils.book_new();
      let wsData = [];

      // Exit if no failed rows
      if (!this.failedRows || this.failedRows.length === 0) return;

      // Case: only one row with a single "Reason" field
      if (
        this.failedRows.length === 1 &&
        Object.keys(this.failedRows[0]).length === 1 &&
        this.failedRows[0].hasOwnProperty("Reason")
      ) {
        const headers = ["Reason"];
        const row = [this.failedRows[0].Reason || ""];
        wsData.push(headers, row);
      } else {
        // Get base headers, excluding 'questionOptions'
        let baseHeaders = Object.keys(this.failedRows[0]).filter(
          (key) => key !== "questionOptions"
        );

        // Move 'Reason' to be the first column if it exists
        baseHeaders = baseHeaders.filter((key) => key !== "Reason");
        baseHeaders.unshift("Reason");

        // Determine the maximum number of options across all rows
        let maxOptionsCount = 0;
        this.failedRows.forEach((row) => {
          const options = row.questionOptions || [];
          if (options.length > maxOptionsCount) {
            maxOptionsCount = options.length;
          }
        });

        // Combine all headers
        const headers = [...baseHeaders];
        wsData.push(headers);

        // Process each failed row
        this.failedRows.forEach((row) => {
          const options = row.questionOptions || [];
          const cleanRow = { ...row };
          delete cleanRow.questionOptions;

          // Build base part of the row
          const baseRow = baseHeaders.map((header) => cleanRow[header] || "");

          // Combine row parts
          const finalRow = [...baseRow];
          wsData.push(finalRow);
        });
      }

      // Create worksheet and workbook
      const ws = XLSX.utils.aoa_to_sheet(wsData);
      XLSX.utils.book_append_sheet(wb, ws, "Failed Uploads");

      // Export as Blob
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], {
        type: "application/octet-stream",
      });

      // Trigger download
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute("download", "failed_uploads.xlsx");
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    decodeHtmlEntities(text) {
      const entities = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'",
        "&nbsp;": " ",
      };
      return text.replace(
        /&(amp|lt|gt|quot|#39|nbsp|#(\d+));/g,
        function (match, entity, dec) {
          if (entity === "quot") return '"';
          if (entity === "#39") return "'";
          return entities[entity] || String.fromCharCode(dec);
        }
      );
    },
    skippedQuestion(id, reason) {
      console.log("reason");
      if (reason == "") {
      } else {
        this.removedQuestion.push(
          "Q" + id + ". Failed" + "->reason-> " + reason
        );
      }
    },
    downloadTextFile(text, filename) {
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    uploadTopics() {
      this.uploadingTopicsDialog = true;
      // console.log('uploadingTopicsDialog',this.uploadingTopicsDialog)
      this.uploadTopicsUsers = false;
      console.log("bulk upload", this.bulkQuestionJsonData);
      var index = 1;
      this.bulkQuestionJsonData.forEach(async (topic_) => {
        try {
          const response = await TopicsController.createTopic(topic_);
          if (response.status == 200) {
            console.log(topic_);
            this.bulkTopicUploadResponse.push({
              topicIndex: index,
              status: "Uploaded Successfully!",
            });
          } else {
            this.bulkTopicUploadResponse.push({
              topicIndex: index,
              status: "Uploaded Failed!",
            });
          }
          index++;
        } catch (error) {
          console.log(error);
        }
        // console.log(this.bulkTopicUploadResponse);
      });
    },

    async goto(step) {
      step = Number(step);
      switch (step) {
        case 1:
          // this.assessmentFormNotFilled();
          if (this.$refs.step1.validate()) {
            this.dLoading = true;
          }
          this.e1 += 1;
          if (this.allQuestions.length > 0) {
            this.calculateTotalMarks();
          }
          await this.$nextTick();
          this.scrollToStepTop();
          break;
        case 2:
          this.createStaticAssessment(this.assessmentData, "PUBLISHED");
          await this.$nextTick();
          this.scrollToStepTop();
          break;
        default:
      }
    },
    async goBack() {
      this.e1 -= 1;
      await this.$nextTick();
      this.scrollToStepTop();
    },
    selectAll(type) {
      if (type === "languages") {
        if (
          this.assessmentData.availableLanguages?.length ===
          this.languageOptions?.length
        ) {
          // If all languages are selected, deselect all
          this.assessmentData.availableLanguages = [...this.defaultLanguages];
        } else {
          // Select all languages
          this.assessmentData.availableLanguages = [...this.languageOptions];
        }
      }
      if (type == "sections") {
        if (
          this.assessmentData.selectedSections?.length ===
          this.sectionsList?.length
        ) {
          this.assessmentData.selectedSections = [];
          this.assessmentData.sections = [];
        } else {
          this.assessmentData.selectedSections = cloneDeep(this.sectionsList);
          this.assessmentData.sections = this.assessmentData.selectedSections.map((sectionName) => ({
            name: sectionName,
            duration: null,
            noOfQuestions: 1,
            isTimedSection: false,
            breakDuration: 0,
          })
      );
        }
      }
      if (type == "skills") {
        if (this.assessmentData.skillIds?.length === this.skillsList?.length) {
          this.assessmentData.skillIds = [];
        } else {
          this.assessmentData.skillIds = this.skillsList.map(({ id }) => id);
        }
        this.handleSkillsInput(this.assessmentData.skillIds);
      }
      if (type == "grades") {
        if (this.assessmentData.grades?.length === this.gradesList?.length) {
          this.assessmentData.grades = [];
        } else {
          this.assessmentData.grades = cloneDeep(this.gradesList);
        }
        this.fetchSections();
      }
    },

    deleteChip(type, item) {
      switch (type) {
        case "languages":
          if (!this.defaultLanguages.includes(item)) {
            let indexOfLanguage =
              this.assessmentData.availableLanguages.indexOf(item);
            this.assessmentData.availableLanguages.splice(indexOfLanguage, 1);
          }
          break;
        case "sections":
          let indexOfSection = this.assessmentData.selectedSections.findIndex(
            (name) => name === item
          );
          this.assessmentData.selectedSections.splice(indexOfSection, 1);
          this.assessmentData.sections.splice(indexOfSection, 1);
          this.handleSectionsChange();
          break;
        case "skillIds":
          let indexOfSkillId = this.assessmentData.skillIds.findIndex(
            (skill) => skill === item
          );
          this.assessmentData.skillIds.splice(indexOfSkillId, 1);
          this.fetchSections();
          break;
        case "grades":
          let indexOfGrades = this.assessmentData.grades.findIndex(
            (grade) => grade === item
          );
          this.assessmentData.grades.splice(indexOfGrades, 1);
          this.fetchSections();
      }
    },
    handleClear(type) {
      if (type === "availableLanguages") {
        this.assessmentData.availableLanguages = [...this.defaultLanguages];
        this.$nextTick(() => {
          this.assessmentData.availableLanguages = [...this.defaultLanguages];
        });
      } else if (type === "sections") {
        this.assessmentData.sections = [];
      }
    },
    getOptions(questionType, options) {
      switch (questionType) {
        case "SINGLE_CHOICE":
          return options;

        case "MULTIPLE_CHOICE":
          return options;

        case "FILL_IN_THE_BLANKS":
          return [];

        case "TRUE_FALSE":
          return [
            {
              optionKey: "A",
              optionValue: "TRUE",
            },
            {
              optionKey: "B",
              optionValue: "FALSE",
            },
          ];
        default:
          break;
      }
    },
    prepareOptions(correctAnswer) {
      const mtfOptions = [];
      const entries = correctAnswer.split(", ");

      // Extract all countries and cities into arrays
      const countries = entries.map((entry) => entry.split(":")[0]);
      const cities = entries.map((entry) => entry.split(":")[1]);

      // Shuffle the cities array
      const shuffledCities = cities.sort(() => Math.random() - 0.5);

      // Create the options with key-value pairs and index
      countries.forEach((country, index) => {
        mtfOptions.push({
          key: country,
          value: shuffledCities[index],
        });
      });

      return mtfOptions;
    },

    onEditorReady(editor) {
      editor.on("afterCommandExec", function (event) {
        var commandName = event.data.name;
        if (
          [
            "ckeditor_wiris_openFormulaEditor",
            "ckeditor_wiris_openFormulaEditorChemistry",
          ].includes(commandName)
        ) {
          setTimeout(() => {
            const wiris_license_overlays =
              document.querySelectorAll(".wrs_tickContainer");
            wiris_license_overlays.forEach((element) => {
              element.remove();
            });
          }, 2000);
        }
      });
    },
    transformQuestions(questions) {
      const transformedQuestions = {};
      questions.forEach((question) => {
        //if block for untransformed questions
        if (question.languageOfQuestion) {
          const {
            questionId,
            languageOfQuestion,
            proficiencyLevel,
            questionStatement,
            questionAssetUrl,
            questionOptions,
            strand,
            topic,
            loCode1,
            loCode2,
            loCode3,
            loCode4,
            subStrand,
            answerExplanation,
            hint,
            ...rest
          } = question;
          if (!transformedQuestions[questionId]) {
            transformedQuestions[questionId] = { ...rest, QuestionDetails: {} };
          }
          transformedQuestions[questionId].QuestionDetails[
            languageOfQuestion.toLowerCase()
          ] = {
            questionStatement,
            questionAssetUrl,
            questionOptions,
            strand,
            topic,
            loCode1,
            loCode2,
            loCode3,
            loCode4,
            subStrand,
            answerExplanation,
            hint,
          };
        }
        //bypass for already transformed questions
        else {
          const { questionId, ...rest } = question;
          transformedQuestions[questionId] = { ...rest };
        }
      });

      return Object.entries(transformedQuestions).map(
        ([questionId, questionData]) => ({
          questionId,
          ...questionData,
        })
      );
    },
    redirectToEditStaticAssessmentQuestion(questionId) {
      let transformedQuestionTobeEdited;
      //code block for fresh creation run
      if (!this.assessmentData.isEdit) {
        // stash questions payload along with assessment data in vuex store
        this.assessmentData.questionsToUpload = [...this.questionsToUpload];
        this.$store.dispatch("setAssessmentData", this.assessmentData);
        transformedQuestionTobeEdited = this.transformQuestions(
          this.questionsToUpload.filter(
            (question) => question.questionId == questionId
          )
        ).pop();
      }

      // code block for edit and drafting runs
      else {
        if (this.questionsToUpload.length > 0)
          this.assessmentData.questionsToUpload = [...this.questionsToUpload];
        this.$store.dispatch("setAssessmentData", this.assessmentData);

        if (
          this.assessmentData.questions.some(
            (question) => question.questionId == questionId
          )
        ) {
          transformedQuestionTobeEdited = this.transformQuestions(
            this.assessmentData.questions.filter(
              (question) => question.questionId == questionId
            )
          ).pop();
        } else {
          transformedQuestionTobeEdited = this.transformQuestions(
            this.assessmentData.questionsToUpload.filter(
              (question) => question.questionId == questionId
            )
          ).pop();
        }
      }

      this.$store.dispatch("setQuestionForEdit", transformedQuestionTobeEdited);
      this.$router.push({
        path: "/edit-static-assessment",
        query: { questionId, tablePageSize: this.tablePageSize },
      });
    },
    // async getSkillsByName(skills){
    //   let response = await StaticAssessmentController.getSkillsByName(skills);
    //   this.skillsList = response.data;
    // },
    async getAssessmentForId(id) {
      this.assessmentData.id = id;
      let response = await StaticAssessmentController.getStaticAssessmentsById(
        id
      );

      if (response.data.flag) {
        this.assessmentData.isEdit = true;
        const data = response.data.assessments[0];
        this.assessmentNameForDisplay = data.assessmentName;

        for (const key in this.assessmentData) {
          if (data[key] !== undefined) {
            this.assessmentData[key] = data[key];
          }
        }

        let sectionDurationSum = 0;
        this.assessmentData.sections = (data.sections || []).map((section) => {
          sectionDurationSum += Number(section.duration) || 0;
          return { isTimedSection: false, breakDuration: 0, ...section };
        });

        // `totalDuration` is persisted as `duration` on the server; fall back
        // to the section sum for older records that pre-date the field.
        const loadedTotalDuration = Number(data.duration);
        this.assessmentData.totalDuration = loadedTotalDuration > 0
          ? loadedTotalDuration
          : sectionDurationSum;

        await this.getUserTypeForGroupName(
          this.assessmentData.audienceRoleGroupId,
          true
        );
        this.assessmentData.skillIds = this.skillsList
          .filter(({ name }) => data.skills.includes(name))
          .map(({ id }) => id);
        await this.handleSkillsInput(this.assessmentData.skillIds, true);
        this.assessmentData.assessmentCategory =
          this.assessmentCategoriesList.find(
            ({ id }) => data.assessmentCategory === id
          ).id;
        this.assessmentData.grades = data.grade;
        this.selectedGrade = data.grade[0];
        this.assessmentData.timerType = data.timerType;
        this.$nextTick(async () => {
          await this.fetchSections(true);
          this.assessmentData.selectedSections = data.sections.map(
            ({ name }) => name
          );
          this.secondLoader = false;
        });

        await this.handleCategoryChange(
          this.assessmentData.assessmentCategory,
          this.assessmentCategoriesList
        );
        if (this.assessmentData.questions.length > 0) {
          await this.resolveQuestionsMedia(
            this.assessmentData.questions,
            this.assessmentData.availableLanguages
          );
          this.allQuestions = this.assessmentData.questions.map(
            ({ QuestionDetails, ...rest }) => {
              return {
                questionStatement: QuestionDetails?.english?.questionStatement,
                strand: QuestionDetails?.english?.strand,
                ...rest,
              };
            }
          );
        }
        this.assessmentData.deletedQuestions =
          this.assessmentData.questions.map(({ questionId }) => questionId);
        this.englishCount = this.countBySubject("English");
        this.mathCount = this.countBySubject("Mathematics");
        this.logicalReasoningCount = this.countBySubject("Logical Reasoning");
        this.scienceCount = this.countBySubject("Science");

        if (this.assessmentData.level !== "")
          this.getGradesMappedToLevels("", true);
        this.preloader = false;
        // if(!this.assessmentFormNotFilled)this.e1=2;
      }
    },
    async resolveQuestionsMedia(questions, availableLanguages) {
      let promises = questions.map(async (question) => {
        availableLanguages.map(async (language) => {
          let questionDetails =
            question.QuestionDetails[language.toLowerCase()];
          if (
            questionDetails?.questionAssetUrl.startsWith(
              "https://drive.google.com/"
            )
          ) {
            questionDetails.resolvedQuestionAssetUrl =
              await this.resolveMediaUrl(questionDetails.questionAssetUrl);
          }
          questionDetails?.questionOptions.map(async (option) => {
            if (option.optionValue.includes("https://drive.google.com/")) {
              option.resolvedOptionUrl = await this.resolveMediaUrl(
                option.optionValue
              );
            }
          });
        });
        return null;
      });
      await Promise.all(promises);
    },
    async resolveMediaUrl(url) {
      let fileId =
        url.indexOf("&id=") > -1
          ? url.split("&id=").pop()
          : url.match(/\/file\/d\/([^\\/]+)\//)[1];
      const response =
        await AssessmentController.doFetchFileContentFromDriveUrl(fileId);
      if (response.status === 200) {
        return window.URL.createObjectURL(new Blob([response.data]));
      } else {
        return new URL(`../assets/caution.png`, import.meta.url).href;
      }
    },
    getQuestionsForLanguage(language, questions) {
      //'questions' can be of two types, transformed(as stored in db) or untransformed(as on csv upload)
      //This function can filter either type or a composite array of questions consisting of both types simultaneously
      let questionsOfLanguage = [];
      questions.forEach(({ QuestionDetails, languageOfQuestion, ...rest }) => {
        if (QuestionDetails) {
          questionsOfLanguage.push({
            questionStatement:
              QuestionDetails[language?.toLowerCase()]?.questionStatement,
            strand: QuestionDetails[language?.toLowerCase()]?.strand,
            ...rest,
          });
        } else if (languageOfQuestion === language) {
          questionsOfLanguage.push({ languageOfQuestion, ...rest });
        }
      });
      return questionsOfLanguage;
    },
    async getSkills() {
      try {
        const {
          data: { flag, skills, message, count },
        } = await SkillsController.getSkills();
        if (flag) {
          const index = skills.indexOf("Psychometry");
          const [item] = skills.splice(index, 1);
          skills.unshift(item);
          return skills;
        } else console.error(message);
      } catch (error) {
        console.error(error);
      }
    },
    async getGroupNames() {
      const { data } = await AudienceRolesController.getAudienceRoleGroups();
      const { audienceRoleGroup, flag } = data;
      if (flag) return audienceRoleGroup;
    },
    async getUserTypeForGroupName(audienceRoleGroupId, isEditRun = false) {
      if (!isEditRun) {
        this.assessmentData.assessmentUserType = "";
      }
      this.userTypeList = [];
      const { userAssessmentMap, flag } =
        await AudienceRolesController.fetchUserAssessmentMap(
          audienceRoleGroupId
        );
      if (flag) this.userTypeList = userAssessmentMap ?? [];
      this.groupNameForDisplay = this.getDisplayNameForId(
        audienceRoleGroupId,
        this.groupNamesList
      );
    },
    async handleSkillsInput(skillIds, isRehydratingForm = false) {
      this.assessmentData.assessmentCategory = "";
      this.assessmentCategoriesList = [];
      const { assessmentCategories, flag } =
        await AudienceRolesController.fetchAssessmentCategories(skillIds);
      if (flag) this.assessmentCategoriesList = assessmentCategories ?? [];
      // if(!isRehydratingForm) await this.fetchSections()
      this.skillNames = this.getDisplayNameForId(skillIds, this.skillsList);
    },
    async handleCategoryChange(categoryId, isRehydratingForm = false) {
      this.clearQuestions();
      this.categoryNameForDisplay = this.getDisplayNameForId(
        categoryId,
        this.assessmentCategoriesList
      );
      this.assessmentSectionId = this.getAssessmentSectionId(
        categoryId,
        this.assessmentCategoriesList
      );
      if (!isRehydratingForm) await this.fetchSections();
    },
    async fetchSections(isRehydratingForm = false) {
      console.log(
        "this.assessmentCategoriesList====>",
        this.assessmentCategoriesList
      );
      this.assessmentData.grades = [this.selectedGrade];
      this.sectionsList = [];
      if (!isRehydratingForm) {
        this.assessmentData.selectedSections = [];
        this.assessmentData.sections = [];
      }
      if (this.assessmentSectionId && this.assessmentSectionId !== "") {
        const { grade, level, sections, flag } =
          await AudienceRolesController.fetchSections(this.assessmentSectionId);

        if (flag) {
          this.sectionsList = sections;
          this.levels = [level];
          this.assessmentData.level = level;
          this.selectedGrade = grade;
          this.gradesList = this.assessmentData.grades = [grade];
        }
      }
    },
    handleTimerTypeChange(){
      this.clearQuestions();
      this.assessmentData.totalDuration = null;
      this.assessmentData.maxBreakDuration = null;
      this.assessmentData.sections.forEach(section => {
        section.duration = 0;
        section.breakDuration = 0;
      })
    },
    handleSectionsChange() {
      this.clearQuestions();
      this.assessmentData.sections = this.assessmentData.selectedSections.map(
        (sectionName) => ({
          name: sectionName,
          noOfQuestions: 1,
          isTimedSection: false,
          duration: null,
          breakDuration: 0,
        })
      );

      if (this.assessmentData.sections.length <= 1) {
        this.assessmentData.isBioBreakIncluded = false;
        this.assessmentData.breakType = "";
        this.assessmentData.maxBreakDuration = null;
      }
    },
    handleSectionTimingChange(event, index){
      const currentSection = this.assessmentData.sections[index];
      if(!currentSection.isTimedSection){
        currentSection.duration = null;
      }
    },
    handleSectionDurationChange(){
      const sections = this.assessmentData.sections || [];
      this.assessmentData.totalDuration = sections.reduce((acc, { duration }) => acc + (Number(duration) || 0), 0);
      this.clearQuestions();
    },
    onSectionDragEnd() {
      const sections = this.assessmentData.sections;
      if (sections.length) {
        sections[sections.length - 1].breakDuration = 0;
      }
    },
    getDisplayNameForId(targetId, list) {
      if (Array.isArray(targetId)) {
        return targetId.map((id) => this.getDisplayNameForId(id, list));
      }
      return list.find(({ id }) => id === targetId)?.name || targetId;
    },
    getAssessmentSectionId(targetId, list) {
      if (Array.isArray(targetId)) {
        return targetId.map((id) => this.getDisplayNameForId(id, list));
      }
      return (
        list.find(({ id }) => id === targetId)?.assessmentSectionId || targetId
      );
    },
    validateUploadSequence(){
      const setSequence = this.assessmentData.sections.map(({ name }) => name);
      const uploadedSequence = [...new Set(this.bulkQuestionJsonData.map(({ strand }) => strand))];

      if (setSequence.length !== uploadedSequence.length) return false;
      return setSequence.every((name, index) => name === uploadedSequence[index]);
    },
    scrollToStepTop(){
      let element = document.querySelectorAll('.current-step-top')[0];
      if(element){
        element.scrollIntoView({
          block: 'nearest',
          inline: 'nearest',
          behavior: 'instant'
        });
      }
    },
  },
  computed: {
    ...mapGetters({
      staticAssessmentData: "getAssessmentData",
      questionForEdit: "getQuestionForEdit",
    }),
    timerTypeList() {
      const list = [
        "Section Level Timer",
        "Question Level Timer",
        "Complete Assessment Timer",
        ...(this.$featureFlags.isEnabled("selective_section_timer_static_assessment") ? ["Selective Section Timer"] : []),
      ];
    
      return list;
    },
    sectionErrorLines() {
      return this.sectionErrorMessage
        ? this.sectionErrorMessage.split("\n")
        : [];
    },
    assessmentFormNotFilled() {
      // getting all mandotory fields
      const {
        modeOfAssessment,
        assessmentName,
        audienceRoleGroupId,
        assessmentUserType,
        skillIds,
        level,
        grades,
        timerType,
        availableLanguages,
        sections,
        isReshuffleRequired,
        isBioBreakIncluded,
        breakType,
        maxBreakDuration,
        totalDuration,
      } = this.assessmentData;

      const isSelective = timerType === "Selective Section Timer";
      const isBlank = (v) => v === "" || v === null || v === undefined;

      let isAnySectionFieldEmpty = false;
      let timedDurationSum = 0;
      
      for (const { duration, noOfQuestions, isTimedSection } of sections) {
        const needsDuration = !isSelective || isTimedSection;
        if (isBlank(noOfQuestions) || (needsDuration && isBlank(duration))) {
          isAnySectionFieldEmpty = true;
        }
        if (isSelective && isTimedSection) {
          timedDurationSum += Number(duration) || 0;
        }
      }

      const isTotalDurationInvalid = isSelective && (
        !(Number(totalDuration) > 0) || Number(totalDuration) < timedDurationSum
      );

      const isAnyBreakFieldValid = isBioBreakIncluded
        ? (breakType !== "" && (isSelective && breakType !== "Break Anytime" ? true : maxBreakDuration > 0 && Number(totalDuration) >= Number(maxBreakDuration)))
        : true;

      return (
        modeOfAssessment === "" ||
        assessmentName === "" ||
        audienceRoleGroupId === "" ||
        assessmentUserType === "" ||
        skillIds.length === 0 ||
        level === "" ||
        grades.length === 0 ||
        timerType === "" ||
        availableLanguages === "" ||
        sections.length === 0 ||
        isAnySectionFieldEmpty ||
        isTotalDurationInvalid ||
        isReshuffleRequired == null ||
        !isAnyBreakFieldValid
      );
    },
    isLastStep() {
      return this.e1 == 2;
    },
    totalQuestions() {
      const { sections, availableLanguages } = this.assessmentData;
      return (
        sections.reduce(
          (totalQuestions, section) =>
            totalQuestions + Number(section.noOfQuestions),
          0
        ) * availableLanguages.length
      );
    },
    sectionStats() {
      const sections = this.assessmentData?.sections;
      if (!Array.isArray(sections) || !sections.length) {
        return {
          timed:   { hint: 'No timed sections',   duration: 0 },
          untimed: { hint: 'No untimed sections', duration: 0 },
        };
      }

      const timed   = sections.filter(s => s.isTimedSection);
      const untimed = sections.filter(s => !s.isTimedSection);

      const names = (list) => list.map(s => s.name);
      const formatHint = (list, fallback) => {
        const n = names(list);
        if (!n.length) return fallback;
        if (n.length <= 2) return n.join(' and ');
        return n.slice(0, -1).join(', ') + ' and ' + n[n.length - 1];
      };

      const timedDuration = timed.reduce((sum, s) => sum + (Number(s.duration) || 0), 0);
      const totalDuration = Number(this.assessmentData.totalDuration) || 0;
      const totalBreakDuration = sections.reduce((sum, {breakDuration}) => sum += (Number(breakDuration) || 0), 0);

      return {
        timed: {
          hint: formatHint(timed, 'No timed sections'),
          duration: timedDuration,
        },
        untimed: {
          hint: formatHint(untimed, 'No untimed sections'),
          duration: Math.max(0, totalDuration - timedDuration),
        },
        all: {
          totalDuration,
          totalBreakDuration
        }
      };
    },
    
  },
  async created() {
    // await this.getRoles();

    this.groupNamesList = await this.getGroupNames();
    this.skillsList = await this.getSkills();
    if (this.$route.query.hasOwnProperty("tablePageSize")) {
      this.tablePageSize = Number(this.$route.query.tablePageSize);
    }

    if (!this.$store.state.role.assessment.read) {
      this.$router.push("/notFound");
    }
    // this.getGrades();
    await this.getLevels();
    this.assessmentData.availableLanguages = [...this.defaultLanguages];
    this.$store.state.breadcrumb = "Assessment";

    //populate form fields when editing assessment
    if (this.$route.query.id !== undefined) {
      this.preloader = true;
      this.secondLoader = true;
      this.getAssessmentForId(this.$route.query.id);
      if (this.$route.query.e1 !== undefined) this.e1 = this.$route.query.e1;
    } else if (this.$route.query.e1 !== undefined) {
      this.preloader = true;
      // unpack assessment data stashed in vuex store
      this.assessmentData = { ...this.staticAssessmentData };
      this.selectedGrade = this.assessmentData.grades[0];
      this.questionsToUpload = [...this.assessmentData.questionsToUpload];
      // populating questions array for display
      this.allQuestions.push(
        ...this.getQuestionsForLanguage("English", [
          ...this.assessmentData.questions,
          ...this.assessmentData.questionsToUpload,
        ])
      );

      //populate dropdown list & fields
      if (this.assessmentData.level !== "")
        this.getGradesMappedToLevels("", true);
      await this.getUserTypeForGroupName(
        this.assessmentData.audienceRoleGroupId
      );
      this.assessmentData.assessmentUserType =
        this.staticAssessmentData.assessmentUserType;
      await this.handleSkillsInput(this.assessmentData.skillIds, true);
      this.assessmentData.assessmentCategory =
        this.staticAssessmentData.assessmentCategory;
      this.categoryNameForDisplay = this.getDisplayNameForId(
        this.staticAssessmentData.assessmentCategory,
        this.assessmentCategoriesList
      );
      this.assessmentSectionId = this.getAssessmentSectionId(
        this.staticAssessmentData.assessmentCategory,
        this.assessmentCategoriesList
      );
      await this.fetchSections(true);
      this.assessmentData.sections = this.staticAssessmentData.sections;

      this.getSubjectCount();
      this.calculateTotalMarks();
      this.e1 = this.$route.query.e1;
    }
    this.preloader = false;
  },
};
</script>

<style scoped>
.drag-ghost {
  opacity: 1 !important;
  background: #f5f7ff;
  border: 1px dashed #b4bcf0;
  border-radius: 12px;
}
.drag-chosen {
  cursor: grabbing;
}
.drag-active {
  opacity: 0.9;
}
.v-data-table {
  th {
    background-color: #ebf2ff;
  }
}
.custom-header-class {
  font-size: 14px !important;
}
.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
  margin-bottom: 0px;
}
.fixBarCreateCammpaign {
  width: 93%;
}
.navigate-form-bar {
  width: calc(100vw - 180px);
  margin-left: 40px;
  background: var(--white) !important;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
.stepper-content-height {
  height: calc(100vh - 220px);
}
.stepper-content-height-step2 {
  height: calc(100vh - 150px);
}

.questions-info {
  position: relative;
  z-index: 10;
}
.question-card {
  position: relative;
  z-index: 1;
  margin-top: -8px;
}
.box2 {
  width: 70rem;
}
.total-questions-and-marks-card {
  border: 1px solid var(--blue-01) !important;
  color: var(--blue-01) !important;
}
.create-assessment-card-outline {
  border: 1px solid #0000001f !important;
}
.total-questions-and-marks-divider {
  border-color: #864f20 !important;
}
.create-assessment-divider {
  border-width: 1px;
}
.label-value {
  color: #000000de !important;
}
.pad-create-assessment {
  padding-top: 48px !important;
}
.radio-group-align {
  margin-top: -8px !important;
}
.stepper-shadow {
  height: 50px;
}
.cke_notification .cke_notification_warning {
  display: none !important;
}
.assessment-details {
  box-shadow: 0px 2px 8px 0px #0000001a !important;
  font-family: "GraphikRegular", sans-serif !important;
}
.min-width-30 {
  min-width: 30%;
}
.fs-3 {
  font-size: 12px;
}
.fs-5 {
  font-size: 20px;
}
.card-shadow{
  box-shadow: 0px 2px 10px 0px #0000001F;
  border-radius: 8px;
}
.drag-handle {
  cursor: grab;
}
.drag-handle:active {
  cursor: grabbing;
}
.disabled-drag {
  opacity: 0.4;
  cursor: not-allowed;
}
.question-statement-cell {
  max-width: 300px; /* Set your desired max width */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* Optional: Add a title attribute for tooltip on hover */
}
.alert-title{
  font-size: 20px !important;
}
.alert-subtitle{
  font-size: 14px !important;
  color: #666666 !important;
}

</style>